export const industryList = [{
	"children": [{
		"children": [{
			"children": [{
				"text": "其他未列明建筑业",
				"value": "5090"
			}],
			"text": "其他未列明建筑业",
			"value": "509"
		}, {
			"children": [{
				"text": "公共建筑装饰和装修",
				"value": "5011"
			}, {
				"text": "住宅装饰和装修",
				"value": "5012"
			}, {
				"text": "建筑幕墙装饰和装修",
				"value": "5013"
			}],
			"text": "建筑装饰和装修业",
			"value": "501"
		}, {
			"children": [{
				"text": "提供施工设备服务",
				"value": "5030"
			}],
			"text": "提供施工设备服务",
			"value": "503"
		}, {
			"children": [{
				"text": "建筑物拆除活动",
				"value": "5021"
			}, {
				"text": "场地准备活动",
				"value": "5022"
			}],
			"text": "建筑物拆除和场地准备活动",
			"value": "502"
		}],
		"text": "建筑装饰、装修和其他建筑业",
		"value": "50"
	}, {
		"children": [{
			"children": [{
				"text": "体育场地设施安装",
				"value": "4991"
			}, {
				"text": "其他建筑安装",
				"value": "4999"
			}],
			"text": "其他建筑安装业",
			"value": "499"
		}, {
			"children": [{
				"text": "电气安装",
				"value": "4910"
			}],
			"text": "电气安装",
			"value": "491"
		}, {
			"children": [{
				"text": "管道和设备安装",
				"value": "4920"
			}],
			"text": "管道和设备安装",
			"value": "492"
		}],
		"text": "建筑安装业",
		"value": "49"
	}, {
		"children": [{
			"children": [{
				"text": "其他房屋建筑业",
				"value": "4790"
			}],
			"text": "其他房屋建筑业",
			"value": "479"
		}, {
			"children": [{
				"text": "体育场馆建筑",
				"value": "4720"
			}],
			"text": "体育场馆建筑",
			"value": "472"
		}, {
			"children": [{
				"text": "住宅房屋建筑",
				"value": "4710"
			}],
			"text": "住宅房屋建筑",
			"value": "471"
		}],
		"text": "房屋建筑业",
		"value": "47"
	}, {
		"children": [{
			"children": [{
				"text": "其他道路、隧道和桥梁工程建筑",
				"value": "4819"
			}, {
				"text": "铁路工程建筑",
				"value": "4811"
			}, {
				"text": "公路工程建筑",
				"value": "4812"
			}, {
				"text": "市政道路工程建筑",
				"value": "4813"
			}, {
				"text": "城市轨道交通工程建筑",
				"value": "4814"
			}],
			"text": "铁路、道路、隧道和桥梁工程建筑",
			"value": "481"
		}, {
			"children": [{
				"text": "火力发电工程施工",
				"value": "4871"
			}, {
				"text": "水力发电工程施工",
				"value": "4872"
			}, {
				"text": "核电工程施工",
				"value": "4873"
			}, {
				"text": "风能发电工程施工",
				"value": "4874"
			}, {
				"text": "太阳能发电工程施工",
				"value": "4875"
			}, {
				"text": "其他电力工程施工",
				"value": "4879"
			}],
			"text": "电力工程施工",
			"value": "487"
		}, {
			"children": [{
				"text": "园林绿化工程施工",
				"value": "4891"
			}, {
				"text": "体育场地设施工程施工",
				"value": "4892"
			}, {
				"text": "游乐设施工程施工",
				"value": "4893"
			}, {
				"text": "其他土木工程建筑施工",
				"value": "4899"
			}],
			"text": "其他土木工程建筑",
			"value": "489"
		}, {
			"children": [{
				"text": "节能工程施工",
				"value": "4861"
			}, {
				"text": "环保工程施工",
				"value": "4862"
			}, {
				"text": "生态保护工程施工",
				"value": "4863"
			}],
			"text": "节能环保工程施工",
			"value": "486"
		}, {
			"children": [{
				"text": "水源及供水设施工程建筑",
				"value": "4821"
			}, {
				"text": "河湖治理及防洪设施工程建筑",
				"value": "4822"
			}, {
				"text": "港口及航运设施工程建筑",
				"value": "4823"
			}],
			"text": "水利和水运工程建筑",
			"value": "482"
		}, {
			"children": [{
				"text": "其他海洋工程建筑",
				"value": "4839"
			}, {
				"text": "海洋油气资源开发利用工程建筑",
				"value": "4831"
			}, {
				"text": "海洋能源开发利用工程建筑",
				"value": "4832"
			}, {
				"text": "海底隧道工程建筑",
				"value": "4833"
			}, {
				"text": "海底设施铺设工程建筑",
				"value": "4834"
			}],
			"text": "海洋工程建筑",
			"value": "483"
		}, {
			"children": [{
				"text": "工矿工程建筑",
				"value": "4840"
			}],
			"text": "工矿工程建筑",
			"value": "484"
		}, {
			"children": [{
				"text": "架线及设备工程建筑",
				"value": "4851"
			}, {
				"text": "管道工程建筑",
				"value": "4852"
			}, {
				"text": "地下综合管廊工程建筑",
				"value": "4853"
			}],
			"text": "架线和管道工程建筑",
			"value": "485"
		}],
		"text": "土木工程建筑业",
		"value": "48"
	}],
	"text": "建筑业",
	"value": "E"
}, {
	"children": [{
		"children": [{
			"children": [{
				"text": "大型车辆装备修理与维护",
				"value": "8112"
			}, {
				"text": "摩托车修理与维护",
				"value": "8113"
			}, {
				"text": "汽车修理与维护",
				"value": "8111"
			}, {
				"text": "助动车等修理与维护",
				"value": "8114"
			}],
			"text": "汽车、摩托车等修理与维护",
			"value": "811"
		}, {
			"children": [{
				"text": "其他未列明日用产品修理业",
				"value": "8199"
			}, {
				"text": "鞋和皮革修理",
				"value": "8192"
			}, {
				"text": "家具和相关物品修理",
				"value": "8193"
			}, {
				"text": "自行车修理",
				"value": "8191"
			}],
			"text": "其他日用产品修理业",
			"value": "819"
		}, {
			"children": [{
				"text": "计算机和辅助设备修理",
				"value": "8121"
			}, {
				"text": "通讯设备修理",
				"value": "8122"
			}, {
				"text": "其他办公设备维修",
				"value": "8129"
			}],
			"text": "计算机和办公设备维修",
			"value": "812"
		}, {
			"children": [{
				"text": "日用电器修理",
				"value": "8132"
			}, {
				"text": "家用电子产品修理",
				"value": "8131"
			}],
			"text": "家用电器修理",
			"value": "813"
		}],
		"text": "机动车、电子产品和日用产品修理业",
		"value": "81"
	}, {
		"children": [{
			"children": [{
				"text": "建筑物清洁服务",
				"value": "8211"
			}, {
				"text": "其他清洁服务",
				"value": "8219"
			}],
			"text": "清洁服务",
			"value": "821"
		}, {
			"children": [{
				"text": "宠物医院服务",
				"value": "8222"
			}, {
				"text": "宠物美容服务",
				"value": "8223"
			}, {
				"text": "宠物饲养",
				"value": "8221"
			}, {
				"text": "宠物寄托收养服务",
				"value": "8224"
			}, {
				"text": "其他宠物服务",
				"value": "8229"
			}],
			"text": "宠物服务",
			"value": "822"
		}, {
			"children": [{
				"text": "其他未列明服务业",
				"value": "8290"
			}],
			"text": "其他未列明服务业",
			"value": "829"
		}],
		"text": "其他服务业",
		"value": "82"
	}, {
		"children": [{
			"children": [{
				"text": "养生保健服务",
				"value": "8053"
			}, {
				"text": "洗浴服务",
				"value": "8051"
			}, {
				"text": "足浴服务",
				"value": "8052"
			}],
			"text": "洗浴和保健养生服务",
			"value": "805"
		}, {
			"children": [{
				"text": "婚姻服务",
				"value": "8070"
			}],
			"text": "婚姻服务",
			"value": "807"
		}, {
			"children": [{
				"text": "摄影扩印服务",
				"value": "8060"
			}],
			"text": "摄影扩印服务",
			"value": "806"
		}, {
			"children": [{
				"text": "家庭服务",
				"value": "8010"
			}],
			"text": "家庭服务",
			"value": "801"
		}, {
			"children": [{
				"text": "殡葬服务",
				"value": "8080"
			}],
			"text": "殡葬服务",
			"value": "808"
		}, {
			"children": [{
				"text": "其他居民服务业",
				"value": "8090"
			}],
			"text": "其他居民服务业",
			"value": "809"
		}, {
			"children": [{
				"text": "理发及美容服务",
				"value": "8040"
			}],
			"text": "理发及美容服务",
			"value": "804"
		}, {
			"children": [{
				"text": "托儿所服务",
				"value": "8020"
			}],
			"text": "托儿所服务",
			"value": "802"
		}, {
			"children": [{
				"text": "洗染服务",
				"value": "8030"
			}],
			"text": "洗染服务",
			"value": "803"
		}],
		"text": "居民服务业",
		"value": "80"
	}],
	"text": "居民服务、修理和其他服务业",
	"value": "O"
}, {
	"children": [{
		"children": [{
			"children": [{
				"text": "其他未列明信息技术服务业",
				"value": "6599"
			}, {
				"text": "呼叫中心",
				"value": "6591"
			}],
			"text": "其他信息技术服务业",
			"value": "659"
		}, {
			"children": [{
				"text": "信息处理和存储支持服务",
				"value": "6550"
			}],
			"text": "信息处理和存储支持服务",
			"value": "655"
		}, {
			"children": [{
				"text": "地理遥感信息服务",
				"value": "6571"
			}, {
				"text": "动漫、游戏数字内容服务",
				"value": "6572"
			}, {
				"text": "其他数字内容服务",
				"value": "6579"
			}],
			"text": "数字内容服务",
			"value": "657"
		}, {
			"children": [{
				"text": "信息技术咨询服务",
				"value": "6560"
			}],
			"text": "信息技术咨询服务",
			"value": "656"
		}, {
			"children": [{
				"text": "基础软件开发",
				"value": "6511"
			}, {
				"text": "应用软件开发",
				"value": "6513"
			}, {
				"text": "支撑软件开发",
				"value": "6512"
			}, {
				"text": "其他软件开发",
				"value": "6519"
			}],
			"text": "软件开发",
			"value": "651"
		}, {
			"children": [{
				"text": "信息系统集成服务",
				"value": "6531"
			}, {
				"text": "物联网技术服务",
				"value": "6532"
			}],
			"text": "信息系统集成和物联网技术服务",
			"value": "653"
		}, {
			"children": [{
				"text": "运行维护服务",
				"value": "6540"
			}],
			"text": "运行维护服务",
			"value": "654"
		}, {
			"children": [{
				"text": "集成电路设计",
				"value": "6520"
			}],
			"text": "集成电路设计",
			"value": "652"
		}],
		"text": "软件和信息技术服务业",
		"value": "65"
	}, {
		"children": [{
			"children": [{
				"text": "固定电信服务",
				"value": "6311"
			}, {
				"text": "移动电信服务",
				"value": "6312"
			}, {
				"text": "其他电信服务",
				"value": "6319"
			}],
			"text": "电信",
			"value": "631"
		}, {
			"children": [{
				"text": "无线广播电视传输服务",
				"value": "6322"
			}, {
				"text": "有线广播电视传输服务",
				"value": "6321"
			}],
			"text": "广播电视传输服务",
			"value": "632"
		}, {
			"children": [{
				"text": "广播电视卫星传输服务",
				"value": "6331"
			}, {
				"text": "其他卫星传输服务",
				"value": "6339"
			}],
			"text": "卫星传输服务",
			"value": "633"
		}],
		"text": "电信、广播电视和卫星传输服务",
		"value": "63"
	}, {
		"children": [{
			"children": [{
				"text": "互联网安全服务",
				"value": "6440"
			}],
			"text": "互联网安全服务",
			"value": "644"
		}, {
			"children": [{
				"text": "互联网接入及相关服务",
				"value": "6410"
			}],
			"text": "互联网接入及相关服务",
			"value": "641"
		}, {
			"children": [{
				"text": "互联网数据服务",
				"value": "6450"
			}],
			"text": "互联网数据服务",
			"value": "645"
		}, {
			"children": [{
				"text": "互联网搜索服务",
				"value": "6421"
			}, {
				"text": "互联网游戏服务",
				"value": "6422"
			}, {
				"text": "互联网其他信息服务",
				"value": "6429"
			}],
			"text": "互联网信息服务",
			"value": "642"
		}, {
			"children": [{
				"text": "互联网生活服务平台",
				"value": "6432"
			}, {
				"text": "互联网生产服务平台",
				"value": "6431"
			}, {
				"text": "互联网公共服务平台",
				"value": "6434"
			}, {
				"text": "互联网科技创新平台",
				"value": "6433"
			}, {
				"text": "其他互联网平台",
				"value": "6439"
			}],
			"text": "互联网平台",
			"value": "643"
		}, {
			"children": [{
				"text": "其他互联网服务",
				"value": "6490"
			}],
			"text": "其他互联网服务",
			"value": "649"
		}],
		"text": "互联网和相关服务",
		"value": "64"
	}],
	"text": "信息传输、软件和信息技术服务业",
	"value": "I"
}, {
	"children": [{
		"children": [{
			"children": [{
				"text": "物业管理",
				"value": "7020"
			}],
			"text": "物业管理",
			"value": "702"
		}, {
			"children": [{
				"text": "房地产中介服务",
				"value": "7030"
			}],
			"text": "房地产中介服务",
			"value": "703"
		}, {
			"children": [{
				"text": "其他房地产业",
				"value": "7090"
			}],
			"text": "其他房地产业",
			"value": "709"
		}, {
			"children": [{
				"text": "房地产开发经营",
				"value": "7010"
			}],
			"text": "房地产开发经营",
			"value": "701"
		}, {
			"children": [{
				"text": "房地产租赁经营",
				"value": "7040"
			}],
			"text": "房地产租赁经营",
			"value": "704"
		}],
		"text": "房地产业",
		"value": "70"
	}],
	"text": "房地产业",
	"value": "K"
}, {
	"children": [{
		"children": [{
			"children": [{
				"text": "花卉种植",
				"value": "143"
			}, {
				"text": "其他园艺作物种植",
				"value": "149"
			}, {
				"text": "蔬菜种植",
				"value": "141"
			}, {
				"text": "食用菌种植",
				"value": "142"
			}],
			"text": "蔬菜、食用菌及园艺作物种植",
			"value": "14"
		}, {
			"children": [{
				"text": "其他饮料作物种植",
				"value": "169"
			}, {
				"text": "坚果种植",
				"value": "161"
			}, {
				"text": "含油果种植",
				"value": "162"
			}, {
				"text": "香料作物种植",
				"value": "163"
			}, {
				"text": "茶叶种植",
				"value": "164"
			}],
			"text": "坚果、含油果、香料和饮料作物种植",
			"value": "16"
		}, {
			"children": [{
				"text": "其他农业",
				"value": "190"
			}],
			"text": "其他农业",
			"value": "19"
		}, {
			"children": [{
				"text": "草种植",
				"value": "181"
			}, {
				"text": "天然草原割草",
				"value": "182"
			}],
			"text": "草种植及割草",
			"value": "18"
		}, {
			"children": [{
				"text": "豆类种植",
				"value": "121"
			}, {
				"text": "油料种植",
				"value": "122"
			}, {
				"text": "薯类种植",
				"value": "123"
			}],
			"text": "豆类、油料和薯类种植",
			"value": "12"
		}, {
			"children": [{
				"text": "麻类种植",
				"value": "132"
			}, {
				"text": "糖料种植",
				"value": "133"
			}, {
				"text": "烟草种植",
				"value": "134"
			}, {
				"text": "棉花种植",
				"value": "131"
			}],
			"text": "棉、麻、糖、烟草种植",
			"value": "13"
		}, {
			"children": [{
				"text": "其他中药材种植",
				"value": "179"
			}, {
				"text": "中草药种植",
				"value": "171"
			}],
			"text": "中药材种植",
			"value": "17"
		}, {
			"children": [{
				"text": "香蕉等亚热带水果种植",
				"value": "154"
			}, {
				"text": "其他水果种植",
				"value": "159"
			}, {
				"text": "仁果类和核果类水果种植",
				"value": "151"
			}, {
				"text": "葡萄种植",
				"value": "152"
			}, {
				"text": "柑橘类种植",
				"value": "153"
			}],
			"text": "水果种植",
			"value": "15"
		}, {
			"children": [{
				"text": "稻谷种植",
				"value": "111"
			}, {
				"text": "小麦种植",
				"value": "112"
			}, {
				"text": "玉米种植",
				"value": "113"
			}, {
				"text": "其他谷物种植",
				"value": "119"
			}],
			"text": "谷物种植",
			"value": "11"
		}],
		"text": "农业",
		"value": "1"
	}, {
		"children": [{
			"children": [{
				"text": "海水捕捞",
				"value": "421"
			}, {
				"text": "内陆捕捞",
				"value": "422"
			}],
			"text": "水产捕捞",
			"value": "42"
		}, {
			"children": [{
				"text": "海水养殖",
				"value": "411"
			}, {
				"text": "内陆养殖",
				"value": "412"
			}],
			"text": "水产养殖",
			"value": "41"
		}],
		"text": "渔业",
		"value": "4"
	}, {
		"children": [{
			"children": [{
				"text": "林木育种",
				"value": "211"
			}, {
				"text": "林木育苗",
				"value": "212"
			}],
			"text": "林木育种和育苗",
			"value": "21"
		}, {
			"children": [{
				"text": "造林和更新",
				"value": "220"
			}],
			"text": "造林和更新",
			"value": "22"
		}, {
			"children": [{
				"text": "竹材采运",
				"value": "242"
			}, {
				"text": "木材采运",
				"value": "241"
			}],
			"text": "木材和竹材采运",
			"value": "24"
		}, {
			"children": [{
				"text": "木竹材林产品采集",
				"value": "251"
			}, {
				"text": "非木竹材林产品采集",
				"value": "252"
			}],
			"text": "林产品采集",
			"value": "25"
		}, {
			"children": [{
				"text": "森林经营和管护",
				"value": "231"
			}, {
				"text": "森林改培",
				"value": "232"
			}],
			"text": "森林经营、管护和改培",
			"value": "23"
		}],
		"text": "林业",
		"value": "2"
	}, {
		"children": [{
			"children": [{
				"text": "种子种苗培育活动",
				"value": "511"
			}, {
				"text": "农业机械活动",
				"value": "512"
			}, {
				"text": "灌溉活动",
				"value": "513"
			}, {
				"text": "农产品初加工活动",
				"value": "514"
			}, {
				"text": "农作物病虫害防治活动",
				"value": "515"
			}, {
				"text": "其他农业专业及辅助性活动",
				"value": "519"
			}],
			"text": "农业专业及辅助性活动",
			"value": "51"
		}, {
			"children": [{
				"text": "林业有害生物防治活动",
				"value": "521"
			}, {
				"text": "森林防火活动",
				"value": "522"
			}, {
				"text": "林产品初级加工活动",
				"value": "523"
			}, {
				"text": "其他林业专业及辅助性活动",
				"value": "529"
			}],
			"text": "林业专业及辅助性活动",
			"value": "52"
		}, {
			"children": [{
				"text": "畜牧良种繁殖活动",
				"value": "531"
			}, {
				"text": "畜禽粪污处理活动",
				"value": "532"
			}, {
				"text": "其他畜牧专业及辅助性活动",
				"value": "539"
			}],
			"text": "畜牧专业及辅助性活动",
			"value": "53"
		}, {
			"children": [{
				"text": "鱼苗及鱼种场活动",
				"value": "541"
			}, {
				"text": "其他渔业专业及辅助性活动",
				"value": "549"
			}],
			"text": "渔业专业及辅助性活动",
			"value": "54"
		}],
		"text": "农、林、牧、渔专业及辅助性活动",
		"value": "5"
	}, {
		"children": [{
			"children": [{
				"text": "其他未列明畜牧业",
				"value": "399"
			}, {
				"text": "兔的饲养",
				"value": "391"
			}, {
				"text": "蜜蜂饲养",
				"value": "392"
			}],
			"text": "其他畜牧业",
			"value": "39"
		}, {
			"children": [{
				"text": "狩猎和捕捉动物",
				"value": "330"
			}],
			"text": "狩猎和捕捉动物",
			"value": "33"
		}, {
			"children": [{
				"text": "牛的饲养",
				"value": "311"
			}, {
				"text": "马的饲养",
				"value": "312"
			}, {
				"text": "猪的饲养",
				"value": "313"
			}, {
				"text": "羊的饲养",
				"value": "314"
			}, {
				"text": "骆驼饲养",
				"value": "315"
			}, {
				"text": "其他牲畜饲养",
				"value": "319"
			}],
			"text": "牲畜饲养",
			"value": "31"
		}, {
			"children": [{
				"text": "鸡的饲养",
				"value": "321"
			}, {
				"text": "鸭的饲养",
				"value": "322"
			}, {
				"text": "鹅的饲养",
				"value": "323"
			}, {
				"text": "其他家禽饲养",
				"value": "329"
			}],
			"text": "家禽饲养",
			"value": "32"
		}],
		"text": "畜牧业",
		"value": "3"
	}],
	"text": "农、林、牧、渔业",
	"value": "A"
}, {
	"children": [{
		"children": [{
			"children": [{
				"text": "土地调查评估服务",
				"value": "7920"
			}],
			"text": "土地调查评估服务",
			"value": "792"
		}, {
			"children": [{
				"text": "土地整治服务",
				"value": "7910"
			}],
			"text": "土地整治服务",
			"value": "791"
		}, {
			"children": [{
				"text": "土地登记服务",
				"value": "7930"
			}],
			"text": "土地登记服务",
			"value": "793"
		}, {
			"children": [{
				"text": "其他土地管理服务",
				"value": "7990"
			}],
			"text": "其他土地管理服务",
			"value": "799"
		}, {
			"children": [{
				"text": "土地登记代理服务",
				"value": "7940"
			}],
			"text": "土地登记代理服务",
			"value": "794"
		}],
		"text": "土地管理业",
		"value": "79"
	}, {
		"children": [{
			"children": [{
				"text": "防洪除涝设施管理",
				"value": "7610"
			}],
			"text": "防洪除涝设施管理",
			"value": "761"
		}, {
			"children": [{
				"text": "其他水利管理业",
				"value": "7690"
			}],
			"text": "其他水利管理业",
			"value": "769"
		}, {
			"children": [{
				"text": "水资源管理",
				"value": "7620"
			}],
			"text": "水资源管理",
			"value": "762"
		}, {
			"children": [{
				"text": "水文服务",
				"value": "7640"
			}],
			"text": "水文服务",
			"value": "764"
		}, {
			"children": [{
				"text": "天然水收集与分配",
				"value": "7630"
			}],
			"text": "天然水收集与分配",
			"value": "763"
		}],
		"text": "水利管理业",
		"value": "76"
	}, {
		"children": [{
			"children": [{
				"text": "绿化管理",
				"value": "7840"
			}],
			"text": "绿化管理",
			"value": "784"
		}, {
			"children": [{
				"text": "环境卫生管理",
				"value": "7820"
			}],
			"text": "环境卫生管理",
			"value": "782"
		}, {
			"children": [{
				"text": "森林公园管理",
				"value": "7862"
			}, {
				"text": "名胜风景区管理",
				"value": "7861"
			}, {
				"text": "其他游览景区管理",
				"value": "7869"
			}],
			"text": "游览景区管理",
			"value": "786"
		}, {
			"children": [{
				"text": "城乡市容管理",
				"value": "7830"
			}],
			"text": "城乡市容管理",
			"value": "783"
		}, {
			"children": [{
				"text": "城市公园管理",
				"value": "7850"
			}],
			"text": "城市公园管理",
			"value": "785"
		}, {
			"children": [{
				"text": "市政设施管理",
				"value": "7810"
			}],
			"text": "市政设施管理",
			"value": "781"
		}],
		"text": "公共设施管理业",
		"value": "78"
	}, {
		"children": [{
			"children": [{
				"text": "水污染治理",
				"value": "7721"
			}, {
				"text": "固体废物治理",
				"value": "7723"
			}, {
				"text": "大气污染治理",
				"value": "7722"
			}, {
				"text": "放射性废物治理",
				"value": "7725"
			}, {
				"text": "危险废物治理",
				"value": "7724"
			}, {
				"text": "噪声与振动控制服务",
				"value": "7727"
			}, {
				"text": "土壤污染治理与修复服务",
				"value": "7726"
			}, {
				"text": "其他污染治理",
				"value": "7729"
			}],
			"text": "环境治理业",
			"value": "772"
		}, {
			"children": [{
				"text": "其他自然保护",
				"value": "7719"
			}, {
				"text": "自然遗迹保护管理",
				"value": "7712"
			}, {
				"text": "自然生态系统保护管理",
				"value": "7711"
			}, {
				"text": "野生植物保护",
				"value": "7714"
			}, {
				"text": "野生动物保护",
				"value": "7713"
			}, {
				"text": "植物园管理服务",
				"value": "7716"
			}, {
				"text": "动物园、水族馆管理服务",
				"value": "7715"
			}],
			"text": "生态保护",
			"value": "771"
		}],
		"text": "生态保护和环境治理业",
		"value": "77"
	}],
	"text": "水利、环境和公共设施管理业",
	"value": "N"
}, {
	"children": [{
		"children": [{
			"children": [{
				"text": "中国共产党机关",
				"value": "9100"
			}],
			"text": "中国共产党机关",
			"value": "910"
		}],
		"text": "中国共产党机关",
		"value": "91"
	}, {
		"children": [{
			"children": [{
				"text": "公共安全管理机构",
				"value": "9223"
			}, {
				"text": "社会事务管理机构",
				"value": "9224"
			}, {
				"text": "综合事务管理机构",
				"value": "9221"
			}, {
				"text": "对外事务管理机构",
				"value": "9222"
			}, {
				"text": "经济事务管理机构",
				"value": "9225"
			}, {
				"text": "行政监督检查机构",
				"value": "9226"
			}],
			"text": "国家行政机构",
			"value": "922"
		}, {
			"children": [{
				"text": "国家权力机构",
				"value": "9210"
			}],
			"text": "国家权力机构",
			"value": "921"
		}, {
			"children": [{
				"text": "人民检察院",
				"value": "9232"
			}, {
				"text": "人民法院",
				"value": "9231"
			}],
			"text": "人民法院和人民检察院",
			"value": "923"
		}, {
			"children": [{
				"text": "其他未列明国家机构",
				"value": "9299"
			}, {
				"text": "消防管理机构",
				"value": "9291"
			}],
			"text": "其他国家机构",
			"value": "929"
		}],
		"text": "国家机构",
		"value": "92"
	}, {
		"children": [{
			"children": [{
				"text": "人民政协",
				"value": "9310"
			}],
			"text": "人民政协",
			"value": "931"
		}, {
			"children": [{
				"text": "民主党派",
				"value": "9320"
			}],
			"text": "民主党派",
			"value": "932"
		}],
		"text": "人民政协、民主党派",
		"value": "93"
	}, {
		"children": [{
			"children": [{
				"text": "共青团",
				"value": "9513"
			}, {
				"text": "工会",
				"value": "9511"
			}, {
				"text": "妇联",
				"value": "9512"
			}, {
				"text": "其他群众团体",
				"value": "9519"
			}],
			"text": "群众团体",
			"value": "951"
		}, {
			"children": [{
				"text": "基金会",
				"value": "9530"
			}],
			"text": "基金会",
			"value": "953"
		}, {
			"children": [{
				"text": "宗教活动场所服务",
				"value": "9542"
			}, {
				"text": "宗教团体服务",
				"value": "9541"
			}],
			"text": "宗教组织",
			"value": "954"
		}, {
			"children": [{
				"text": "专业性团体",
				"value": "9521"
			}, {
				"text": "行业性团体",
				"value": "9522"
			}, {
				"text": "其他社会团体",
				"value": "9529"
			}],
			"text": "社会团体",
			"value": "952"
		}],
		"text": "群众团体、社会团体和其他成员组织",
		"value": "95"
	}, {
		"children": [{
			"children": [{
				"text": "其他社会保障",
				"value": "9490"
			}],
			"text": "其他社会保障",
			"value": "949"
		}, {
			"children": [{
				"text": "补充保险",
				"value": "9420"
			}],
			"text": "补充保险",
			"value": "942"
		}, {
			"children": [{
				"text": "基本养老保险",
				"value": "9411"
			}, {
				"text": "工伤保险",
				"value": "9414"
			}, {
				"text": "生育保险",
				"value": "9415"
			}, {
				"text": "基本医疗保险",
				"value": "9412"
			}, {
				"text": "失业保险",
				"value": "9413"
			}, {
				"text": "其他基本保险",
				"value": "9419"
			}],
			"text": "基本保险",
			"value": "941"
		}],
		"text": "社会保障",
		"value": "94"
	}, {
		"children": [{
			"children": [{
				"text": "社区居民自治组织",
				"value": "9610"
			}],
			"text": "社区居民自治组织",
			"value": "961"
		}, {
			"children": [{
				"text": "村民自治组织",
				"value": "9620"
			}],
			"text": "村民自治组织",
			"value": "962"
		}],
		"text": "基层群众自治组织及其他组织",
		"value": "96"
	}],
	"text": "公共管理、社会保障和社会组织",
	"value": "S"
}, {
	"children": [{
		"children": [{
			"children": [{
				"text": "休闲娱乐用品设备出租",
				"value": "7121"
			}, {
				"text": "文化用品设备出租",
				"value": "7123"
			}, {
				"text": "体育用品设备出租",
				"value": "7122"
			}, {
				"text": "音像制品出租",
				"value": "7125"
			}, {
				"text": "图书出租",
				"value": "7124"
			}, {
				"text": "其他文体设备和用品出租",
				"value": "7129"
			}],
			"text": "文体设备和用品出租",
			"value": "712"
		}, {
			"children": [{
				"text": "日用品出租",
				"value": "7130"
			}],
			"text": "日用品出租",
			"value": "713"
		}, {
			"children": [{
				"text": "农业机械经营租赁",
				"value": "7112"
			}, {
				"text": "汽车租赁",
				"value": "7111"
			}, {
				"text": "计算机及通讯设备经营租赁",
				"value": "7114"
			}, {
				"text": "建筑工程机械与设备经营租赁",
				"value": "7113"
			}, {
				"text": "医疗设备经营租赁",
				"value": "7115"
			}, {
				"text": "其他机械与设备经营租赁",
				"value": "7119"
			}],
			"text": "机械设备经营租赁",
			"value": "711"
		}],
		"text": "租赁业",
		"value": "71"
	}, {
		"children": [{
			"children": [{
				"text": "创业指导服务",
				"value": "7264"
			}, {
				"text": "劳务派遣服务",
				"value": "7263"
			}, {
				"text": "其他人力资源服务",
				"value": "7269"
			}, {
				"text": "职业中介服务",
				"value": "7262"
			}, {
				"text": "公共就业服务",
				"value": "7261"
			}],
			"text": "人力资源服务",
			"value": "726"
		}, {
			"children": [{
				"text": "其他广告服务",
				"value": "7259"
			}, {
				"text": "互联网广告服务",
				"value": "7251"
			}],
			"text": "广告业",
			"value": "725"
		}, {
			"children": [{
				"text": "其他安全保护服务",
				"value": "7279"
			}, {
				"text": "安全保护服务 安全服务",
				"value": "7271"
			}, {
				"text": "安全系统监控服务",
				"value": "7272"
			}],
			"text": "安全保护服务 安全服务",
			"value": "727"
		}, {
			"children": [{
				"text": "市场调查",
				"value": "7242"
			}, {
				"text": "会计、审计及税务服务",
				"value": "7241"
			}, {
				"text": "健康咨询",
				"value": "7244"
			}, {
				"text": "社会经济咨询",
				"value": "7243"
			}, {
				"text": "体育咨询",
				"value": "7246"
			}, {
				"text": "环保咨询",
				"value": "7245"
			}, {
				"text": "其他专业咨询与调查",
				"value": "7249"
			}],
			"text": "咨询与调查",
			"value": "724"
		}, {
			"children": [{
				"text": "律师及相关法律服务",
				"value": "7231"
			}, {
				"text": "公证服务",
				"value": "7232"
			}, {
				"text": "其他法律服务",
				"value": "7239"
			}],
			"text": "法律服务",
			"value": "723"
		}, {
			"children": [{
				"text": "商业综合体管理服务",
				"value": "7222"
			}, {
				"text": "园区管理服务",
				"value": "7221"
			}, {
				"text": "供应链管理服务",
				"value": "7224"
			}, {
				"text": "市场管理服务",
				"value": "7223"
			}, {
				"text": "其他综合管理服务",
				"value": "7229"
			}],
			"text": "综合管理服务",
			"value": "722"
		}, {
			"children": [{
				"text": "商务代理代办服务",
				"value": "7297"
			}, {
				"text": "非融资担保服务",
				"value": "7296"
			}, {
				"text": "其他未列明商务服务业",
				"value": "7299"
			}, {
				"text": "票务代理服务",
				"value": "7298"
			}, {
				"text": "旅行社及相关服务",
				"value": "7291"
			}, {
				"text": "办公服务",
				"value": "7293"
			}, {
				"text": "包装服务",
				"value": "7292"
			}, {
				"text": "信用服务",
				"value": "7295"
			}, {
				"text": "翻译服务",
				"value": "7294"
			}],
			"text": "其他商务服务业",
			"value": "729"
		}, {
			"children": [{
				"text": "企业总部管理",
				"value": "7211"
			}, {
				"text": "资源与产权交易服务",
				"value": "7213"
			}, {
				"text": "投资与资产管理",
				"value": "7212"
			}, {
				"text": "农村集体经济组织管理",
				"value": "7215"
			}, {
				"text": "单位后勤管理服务",
				"value": "7214"
			}, {
				"text": "其他组织管理服务",
				"value": "7219"
			}],
			"text": "组织管理服务",
			"value": "721"
		}, {
			"children": [{
				"text": "其他会议、会展及相关服务",
				"value": "7289"
			}, {
				"text": "旅游会展服务",
				"value": "7282"
			}, {
				"text": "科技会展服务",
				"value": "7281"
			}, {
				"text": "文化会展服务",
				"value": "7284"
			}, {
				"text": "体育会展服务",
				"value": "7283"
			}],
			"text": "会议、展览及相关服务",
			"value": "728"
		}],
		"text": "商务服务业",
		"value": "72"
	}],
	"text": "租赁和商务服务业",
	"value": "L"
}, {
	"children": [{
		"children": [{
			"children": [{
				"text": "海上旅客运输",
				"value": "5511"
			}, {
				"text": "内河旅客运输",
				"value": "5512"
			}, {
				"text": "客运轮渡运输",
				"value": "5513"
			}],
			"text": "水上旅客运输",
			"value": "551"
		}, {
			"children": [{
				"text": "远洋货物运输",
				"value": "5521"
			}, {
				"text": "沿海货物运输",
				"value": "5522"
			}, {
				"text": "内河货物运输",
				"value": "5523"
			}],
			"text": "水上货物运输",
			"value": "552"
		}, {
			"children": [{
				"text": "客运港口",
				"value": "5531"
			}, {
				"text": "货运港口",
				"value": "5532"
			}, {
				"text": "其他水上运输辅助活动",
				"value": "5539"
			}],
			"text": "水上运输辅助活动",
			"value": "553"
		}],
		"text": "水上运输业",
		"value": "55"
	}, {
		"children": [{
			"children": [{
				"text": "公共电汽车客运",
				"value": "5411"
			}, {
				"text": "城市轨道交通",
				"value": "5412"
			}, {
				"text": "出租车客运",
				"value": "5413"
			}, {
				"text": "公共自行车服务",
				"value": "5414"
			}, {
				"text": "其他城市公共交通运输",
				"value": "5419"
			}],
			"text": "城市公共交通运输",
			"value": "541"
		}, {
			"children": [{
				"text": "普通货物道路运输",
				"value": "5431"
			}, {
				"text": "冷藏车道路运输",
				"value": "5432"
			}, {
				"text": "集装箱道路运输",
				"value": "5433"
			}, {
				"text": "大型货物道路运输",
				"value": "5434"
			}, {
				"text": "危险货物道路运输",
				"value": "5435"
			}, {
				"text": "邮件包裹道路运输",
				"value": "5436"
			}, {
				"text": "城市配送",
				"value": "5437"
			}, {
				"text": "搬家运输",
				"value": "5438"
			}, {
				"text": "其他道路货物运输",
				"value": "5439"
			}],
			"text": "道路货物运输",
			"value": "543"
		}, {
			"children": [{
				"text": "客运汽车站",
				"value": "5441"
			}, {
				"text": "货运枢纽（站）",
				"value": "5442"
			}, {
				"text": "公路管理与养护",
				"value": "5443"
			}, {
				"text": "其他道路运输辅助活动",
				"value": "5449"
			}],
			"text": "道路运输辅助活动",
			"value": "544"
		}, {
			"children": [{
				"text": "长途客运",
				"value": "5421"
			}, {
				"text": "旅游客运",
				"value": "5422"
			}, {
				"text": "其他公路客运",
				"value": "5429"
			}],
			"text": "公路旅客运输",
			"value": "542"
		}],
		"text": "道路运输业",
		"value": "54"
	}, {
		"children": [{
			"children": [{
				"text": "其他运输代理业",
				"value": "5829"
			}, {
				"text": "货物运输代理",
				"value": "5821"
			}, {
				"text": "旅客票务代理",
				"value": "5822"
			}],
			"text": "运输代理业",
			"value": "582"
		}, {
			"children": [{
				"text": "多式联运",
				"value": "5810"
			}],
			"text": "多式联运",
			"value": "581"
		}],
		"text": "多式联运和运输代理业",
		"value": "58"
	}, {
		"children": [{
			"children": [{
				"text": "客运火车站",
				"value": "5331"
			}, {
				"text": "货运火车站（场）",
				"value": "5332"
			}, {
				"text": "铁路运输维护活动",
				"value": "5333"
			}, {
				"text": "其他铁路运输辅助活动",
				"value": "5339"
			}],
			"text": "铁路运输辅助活动",
			"value": "533"
		}, {
			"children": [{
				"text": "高速铁路旅客运输",
				"value": "5311"
			}, {
				"text": "城际铁路旅客运输",
				"value": "5312"
			}, {
				"text": "普通铁路旅客运输",
				"value": "5313"
			}],
			"text": "铁路旅客运输",
			"value": "531"
		}, {
			"children": [{
				"text": "铁路货物运输",
				"value": "5320"
			}],
			"text": "铁路货物运输",
			"value": "532"
		}],
		"text": "铁路运输业",
		"value": "53"
	}, {
		"children": [{
			"children": [{
				"text": "机场",
				"value": "5631"
			}, {
				"text": "空中交通管理",
				"value": "5632"
			}, {
				"text": "其他航空运输辅助活动",
				"value": "5639"
			}],
			"text": "航空运输辅助活动",
			"value": "563"
		}, {
			"children": [{
				"text": "航空旅客运输",
				"value": "5611"
			}, {
				"text": "航空货物运输",
				"value": "5612"
			}],
			"text": "航空客货运输",
			"value": "561"
		}, {
			"children": [{
				"text": "其他通用航空服务",
				"value": "5629"
			}, {
				"text": "通用航空生产服务",
				"value": "5621"
			}, {
				"text": "观光游览航空服务",
				"value": "5622"
			}, {
				"text": "体育航空运动服务",
				"value": "5623"
			}],
			"text": "通用航空服务",
			"value": "562"
		}],
		"text": "航空运输业",
		"value": "56"
	}, {
		"children": [{
			"children": [{
				"text": "陆地管道运输",
				"value": "5720"
			}],
			"text": "陆地管道运输",
			"value": "572"
		}, {
			"children": [{
				"text": "海底管道运输",
				"value": "5710"
			}],
			"text": "海底管道运输",
			"value": "571"
		}],
		"text": "管道运输业",
		"value": "57"
	}, {
		"children": [{
			"children": [{
				"text": "其他仓储业",
				"value": "5990"
			}],
			"text": "其他仓储业",
			"value": "599"
		}, {
			"children": [{
				"text": "其他农产品仓储",
				"value": "5959"
			}, {
				"text": "谷物仓储",
				"value": "5951"
			}, {
				"text": "棉花仓储",
				"value": "5952"
			}],
			"text": "谷物、棉花等农产品仓储",
			"value": "595"
		}, {
			"children": [{
				"text": "装卸搬运",
				"value": "5910"
			}],
			"text": "装卸搬运",
			"value": "591"
		}, {
			"children": [{
				"text": "中药材仓储",
				"value": "5960"
			}],
			"text": "中药材仓储",
			"value": "596"
		}, {
			"children": [{
				"text": "通用仓储",
				"value": "5920"
			}],
			"text": "通用仓储",
			"value": "592"
		}, {
			"children": [{
				"text": "低温仓储",
				"value": "5930"
			}],
			"text": "低温仓储",
			"value": "593"
		}, {
			"children": [{
				"text": "其他危险品仓储",
				"value": "5949"
			}, {
				"text": "油气仓储",
				"value": "5941"
			}, {
				"text": "危险化学品仓储",
				"value": "5942"
			}],
			"text": "危险品仓储",
			"value": "594"
		}],
		"text": "装卸搬运和仓储业",
		"value": "59"
	}, {
		"children": [{
			"children": [{
				"text": "其他寄递服务",
				"value": "6090"
			}],
			"text": "其他寄递服务",
			"value": "609"
		}, {
			"children": [{
				"text": "邮政基本服务",
				"value": "6010"
			}],
			"text": "邮政基本服务",
			"value": "601"
		}, {
			"children": [{
				"text": "快递服务",
				"value": "6020"
			}],
			"text": "快递服务",
			"value": "602"
		}],
		"text": "邮政业",
		"value": "60"
	}],
	"text": "交通运输、仓储和邮政业",
	"value": "G"
}, {
	"children": [{
		"children": [{
			"children": [{
				"text": "生物质燃气生产和供应业",
				"value": "4520"
			}],
			"text": "生物质燃气生产和供应业",
			"value": "452"
		}, {
			"children": [{
				"text": "天然气生产和供应业",
				"value": "4511"
			}, {
				"text": "液化石油气生产和供应业",
				"value": "4512"
			}, {
				"text": "煤气生产和供应业",
				"value": "4513"
			}],
			"text": "燃气生产和供应业",
			"value": "451"
		}],
		"text": "燃气生产和供应业 ",
		"value": "45"
	}, {
		"children": [{
			"children": [{
				"text": "热力生产和供应",
				"value": "4430"
			}],
			"text": "热力生产和供应",
			"value": "443"
		}, {
			"children": [{
				"text": "其他电力生产",
				"value": "4419"
			}, {
				"text": "火力发电",
				"value": "4411"
			}, {
				"text": "热电联产",
				"value": "4412"
			}, {
				"text": "水力发电",
				"value": "4413"
			}, {
				"text": "核力发电",
				"value": "4414"
			}, {
				"text": "风力发电",
				"value": "4415"
			}, {
				"text": "太阳能发电",
				"value": "4416"
			}, {
				"text": "生物质能发电",
				"value": "4417"
			}],
			"text": "电力生产",
			"value": "441"
		}, {
			"children": [{
				"text": "电力供应",
				"value": "4420"
			}],
			"text": "电力供应",
			"value": "442"
		}],
		"text": "电力、热力生产和供应业",
		"value": "44"
	}, {
		"children": [{
			"children": [{
				"text": "污水处理及其再生利用",
				"value": "4620"
			}],
			"text": "污水处理及其再生利用",
			"value": "462"
		}, {
			"children": [{
				"text": "其他水的处理、利用与分配",
				"value": "4690"
			}],
			"text": "其他水的处理、利用与分配",
			"value": "469"
		}, {
			"children": [{
				"text": "自来水生产和供应",
				"value": "4610"
			}],
			"text": "自来水生产和供应",
			"value": "461"
		}, {
			"children": [{
				"text": "海水淡化处理",
				"value": "4630"
			}],
			"text": "海水淡化处理",
			"value": "463"
		}],
		"text": "水的生产和供应业",
		"value": "46"
	}],
	"text": "电力、热力、燃气及水生产和供应业",
	"value": "D"
}, {
	"children": [{
		"children": [{
			"children": [{
				"text": "广播电视集成播控",
				"value": "8740"
			}],
			"text": "广播电视集成播控",
			"value": "874"
		}, {
			"children": [{
				"text": "电视",
				"value": "8720"
			}],
			"text": "电视",
			"value": "872"
		}, {
			"children": [{
				"text": "广播",
				"value": "8710"
			}],
			"text": "广播",
			"value": "871"
		}, {
			"children": [{
				"text": "录音制作",
				"value": "8770"
			}],
			"text": "录音制作",
			"value": "877"
		}, {
			"children": [{
				"text": "影视节目制作",
				"value": "8730"
			}],
			"text": "影视节目制作",
			"value": "873"
		}, {
			"children": [{
				"text": "电影放映",
				"value": "8760"
			}],
			"text": "电影放映",
			"value": "876"
		}, {
			"children": [{
				"text": "电影和广播电视节目发行",
				"value": "8750"
			}],
			"text": "电影和广播电视节目发行",
			"value": "875"
		}],
		"text": "广播、电视、电影和录音制作业",
		"value": "87"
	}, {
		"children": [{
			"children": [{
				"text": "文物及非物质文化遗产保护",
				"value": "8840"
			}],
			"text": "文物及非物质文化遗产保护",
			"value": "884"
		}, {
			"children": [{
				"text": "文艺创作与表演",
				"value": "8810"
			}],
			"text": "文艺创作与表演",
			"value": "881"
		}, {
			"children": [{
				"text": "图书馆",
				"value": "8831"
			}, {
				"text": "档案馆",
				"value": "8832"
			}],
			"text": "图书馆与档案馆",
			"value": "883"
		}, {
			"children": [{
				"text": "其他文化艺术业",
				"value": "8890"
			}],
			"text": "其他文化艺术业",
			"value": "889"
		}, {
			"children": [{
				"text": "博物馆",
				"value": "8850"
			}],
			"text": "博物馆",
			"value": "885"
		}, {
			"children": [{
				"text": "群众文体活动",
				"value": "8870"
			}],
			"text": "群众文体活动",
			"value": "887"
		}, {
			"children": [{
				"text": "烈士陵园、纪念馆",
				"value": "8860"
			}],
			"text": "烈士陵园、纪念馆",
			"value": "886"
		}, {
			"children": [{
				"text": "艺术表演场馆",
				"value": "8820"
			}],
			"text": "艺术表演场馆",
			"value": "882"
		}],
		"text": "文化艺术业",
		"value": "88"
	}, {
		"children": [{
			"children": [{
				"text": "其他体育组织",
				"value": "8919"
			}, {
				"text": "体育保障组织",
				"value": "8912"
			}, {
				"text": "体育竞赛组织",
				"value": "8911"
			}],
			"text": "体育组织",
			"value": "891"
		}, {
			"children": [{
				"text": "其他体育场地设施管理",
				"value": "8929"
			}, {
				"text": "体育场馆管理",
				"value": "8921"
			}],
			"text": "体育场地设施管理",
			"value": "892"
		}, {
			"children": [{
				"text": "体育健康服务",
				"value": "8992"
			}, {
				"text": "体育中介代理服务",
				"value": "8991"
			}, {
				"text": "其他未列明体育",
				"value": "8999"
			}],
			"text": "其他体育",
			"value": "899"
		}, {
			"children": [{
				"text": "健身休闲活动",
				"value": "8930"
			}],
			"text": "健身休闲活动",
			"value": "893"
		}],
		"text": "体育",
		"value": "89"
	}, {
		"children": [{
			"children": [{
				"text": "报纸出版",
				"value": "8622"
			}, {
				"text": "期刊出版",
				"value": "8623"
			}, {
				"text": "图书出版",
				"value": "8621"
			}, {
				"text": "数字出版",
				"value": "8626"
			}, {
				"text": "音像制品出版",
				"value": "8624"
			}, {
				"text": "电子出版物出版",
				"value": "8625"
			}, {
				"text": "其他出版业",
				"value": "8629"
			}],
			"text": "出版业",
			"value": "862"
		}, {
			"children": [{
				"text": "新闻业",
				"value": "8610"
			}],
			"text": "新闻业",
			"value": "861"
		}],
		"text": "新闻和出版业",
		"value": "86"
	}, {
		"children": [{
			"children": [{
				"text": "休闲观光活动",
				"value": "9030"
			}],
			"text": "休闲观光活动",
			"value": "903"
		}, {
			"children": [{
				"text": "其他娱乐业",
				"value": "9090"
			}],
			"text": "其他娱乐业",
			"value": "909"
		}, {
			"children": [{
				"text": "其他彩票服务",
				"value": "9049"
			}, {
				"text": "体育彩票服务",
				"value": "9041"
			}, {
				"text": "福利彩票服务",
				"value": "9042"
			}],
			"text": "彩票活动",
			"value": "904"
		}, {
			"children": [{
				"text": "游乐园",
				"value": "9020"
			}],
			"text": "游乐园",
			"value": "902"
		}, {
			"children": [{
				"text": "其他文化艺术经纪代理",
				"value": "9059"
			}, {
				"text": "文化体育娱乐活动与经纪代理服务 文化活动服务",
				"value": "9051"
			}, {
				"text": "体育经纪人",
				"value": "9054"
			}, {
				"text": "体育表演服务",
				"value": "9052"
			}, {
				"text": "文化娱乐经纪人",
				"value": "9053"
			}],
			"text": "文化体育娱乐活动与经纪代理服务 文化活动服务",
			"value": "905"
		}, {
			"children": [{
				"text": "电子游艺厅娱乐活动",
				"value": "9012"
			}, {
				"text": "网吧活动",
				"value": "9013"
			}, {
				"text": "其他室内娱乐活动",
				"value": "9019"
			}, {
				"text": "歌舞厅娱乐活动",
				"value": "9011"
			}],
			"text": "室内娱乐活动",
			"value": "901"
		}],
		"text": "娱乐业",
		"value": "90"
	}],
	"text": "文化、体育和娱乐业",
	"value": "R"
}, {
	"children": [{
		"children": [{
			"children": [{
				"text": "其他娱乐用品制造",
				"value": "2469"
			}, {
				"text": "游艺用品及室内游艺器材制造",
				"value": "2462"
			}, {
				"text": "露天游乐场所游乐设备制造",
				"value": "2461"
			}],
			"text": "游艺器材及娱乐用品制造",
			"value": "246"
		}, {
			"children": [{
				"text": "其他体育用品制造",
				"value": "2449"
			}, {
				"text": "运动防护用具制造",
				"value": "2444"
			}, {
				"text": "健身器材制造",
				"value": "2443"
			}, {
				"text": "专项运动器材及配件制造",
				"value": "2442"
			}, {
				"text": "球类制造",
				"value": "2441"
			}],
			"text": "体育用品制造",
			"value": "244"
		}, {
			"children": [{
				"text": "珠宝首饰及有关物品制造",
				"value": "2438"
			}, {
				"text": "地毯、挂毯制造",
				"value": "2437"
			}, {
				"text": "抽纱刺绣工艺品制造",
				"value": "2436"
			}, {
				"text": "天然植物纤维编织工艺品制造",
				"value": "2435"
			}, {
				"text": "花画工艺品制造",
				"value": "2434"
			}, {
				"text": "漆器工艺品制造",
				"value": "2433"
			}, {
				"text": "金属工艺品制造",
				"value": "2432"
			}, {
				"text": "雕塑工艺品制造",
				"value": "2431"
			}, {
				"text": "其他工艺美术及礼仪用品制造",
				"value": "2439"
			}],
			"text": "工艺美术及礼仪用品制造",
			"value": "243"
		}, {
			"children": [{
				"text": "电子乐器制造",
				"value": "2423"
			}, {
				"text": "西乐器制造",
				"value": "2422"
			}, {
				"text": "中乐器制造",
				"value": "2421"
			}, {
				"text": "其他乐器及零件制造",
				"value": "2429"
			}],
			"text": "乐器制造",
			"value": "242"
		}, {
			"children": [{
				"text": "其他玩具制造",
				"value": "2459"
			}, {
				"text": "儿童乘骑玩耍的童车类产品制造",
				"value": "2456"
			}, {
				"text": "娃娃玩具制造",
				"value": "2455"
			}, {
				"text": "弹射玩具制造",
				"value": "2454"
			}, {
				"text": "金属玩具制造",
				"value": "2453"
			}, {
				"text": "塑胶玩具制造",
				"value": "2452"
			}, {
				"text": "电玩具制造",
				"value": "2451"
			}],
			"text": "玩具制造",
			"value": "245"
		}, {
			"children": [{
				"text": "墨水、墨汁制造",
				"value": "2414"
			}, {
				"text": "教学用模型及教具制造",
				"value": "2413"
			}, {
				"text": "笔的制造",
				"value": "2412"
			}, {
				"text": "文具制造",
				"value": "2411"
			}, {
				"text": "其他文教办公用品制造",
				"value": "2419"
			}],
			"text": "文教办公用品制造",
			"value": "241"
		}],
		"text": "文教、工美、体育和娱乐用品制造业",
		"value": "24"
	}, {
		"children": [{
			"children": [{
				"text": "软木制品及其他木制品制造",
				"value": "2039"
			}, {
				"text": "木制容器制造",
				"value": "2035"
			}, {
				"text": "木地板制造",
				"value": "2034"
			}, {
				"text": "木楼梯制造",
				"value": "2033"
			}, {
				"text": "木门窗制造",
				"value": "2032"
			}, {
				"text": "建筑用木料及木材组件加工",
				"value": "2031"
			}],
			"text": "木质制品制造",
			"value": "203"
		}, {
			"children": [{
				"text": "草及其他制品制造",
				"value": "2049"
			}, {
				"text": "棕制品制造",
				"value": "2043"
			}, {
				"text": "藤制品制造",
				"value": "2042"
			}, {
				"text": "竹制品制造",
				"value": "2041"
			}],
			"text": "竹、藤、棕、草等制品制造",
			"value": "204"
		}, {
			"children": [{
				"text": "其他人造板制造",
				"value": "2029"
			}, {
				"text": "刨花板制造",
				"value": "2023"
			}, {
				"text": "纤维板制造",
				"value": "2022"
			}, {
				"text": "胶合板制造",
				"value": "2021"
			}],
			"text": "人造板制造",
			"value": "202"
		}, {
			"children": [{
				"text": "其他木材加工",
				"value": "2019"
			}, {
				"text": "单板加工",
				"value": "2013"
			}, {
				"text": "木片加工",
				"value": "2012"
			}, {
				"text": "锯材加工",
				"value": "2011"
			}],
			"text": "木材加工",
			"value": "201"
		}],
		"text": "木材加工和木、竹、藤、棕、草制品业",
		"value": "20"
	}, {
		"children": [{
			"children": [{
				"text": "饲料生产专用设备制造",
				"value": "3534"
			}, {
				"text": "烟草生产专用设备制造",
				"value": "3533"
			}, {
				"text": "农副食品加工专用设备制造",
				"value": "3532"
			}, {
				"text": "食品、酒、饮料及茶生产专用设备制造",
				"value": "3531"
			}],
			"text": "食品、饮料、烟草及饲料生产专用设备制造",
			"value": "353"
		}, {
			"children": [{
				"text": "冶金专用设备制造",
				"value": "3516"
			}, {
				"text": "建筑材料生产专用机械制造",
				"value": "3515"
			}, {
				"text": "建筑工程用机械制造",
				"value": "3514"
			}, {
				"text": "深海石油钻探设备制造",
				"value": "3513"
			}, {
				"text": "石油钻采专用设备制造",
				"value": "3512"
			}, {
				"text": "矿山机械制造",
				"value": "3511"
			}, {
				"text": "隧道施工专用机械制造",
				"value": "3517"
			}],
			"text": "采矿、冶金、建筑专用设备制造",
			"value": "351"
		}, {
			"children": [{
				"text": "模具制造",
				"value": "3525"
			}, {
				"text": "木竹材加工机械制造",
				"value": "3524"
			}, {
				"text": "塑料加工专用设备制造",
				"value": "3523"
			}, {
				"text": "橡胶加工专用设备制造",
				"value": "3522"
			}, {
				"text": "炼油、化工生产专用设备制造",
				"value": "3521"
			}, {
				"text": "其他非金属加工专用设备制造",
				"value": "3529"
			}],
			"text": "化工、木材、非金属加工专用设备制造",
			"value": "352"
		}, {
			"children": [{
				"text": "其他专用设备制造",
				"value": "3599"
			}, {
				"text": "水资源专用机械制造",
				"value": "3597"
			}, {
				"text": "交通安全、管制及类似专用设备制造",
				"value": "3596"
			}, {
				"text": "社会公共安全设备及器材制造",
				"value": "3595"
			}, {
				"text": "商业、饮食、服务专用设备制造",
				"value": "3594"
			}, {
				"text": "邮政专用机械及器材制造",
				"value": "3593"
			}, {
				"text": "地质勘查专用设备制造",
				"value": "3592"
			}, {
				"text": "环境保护专用设备制造",
				"value": "3591"
			}],
			"text": "环保、邮政、社会公共服务及其他专用设备制造",
			"value": "359"
		}, {
			"children": [{
				"text": "其他日用品生产专用设备制造",
				"value": "3549"
			}, {
				"text": "玻璃、陶瓷和搪瓷制品生产专用设备制造",
				"value": "3546"
			}, {
				"text": "照明器具生产专用设备制造",
				"value": "3545"
			}, {
				"text": "制药专用设备制造",
				"value": "3544"
			}, {
				"text": "日用化工专用设备制造",
				"value": "3543"
			}, {
				"text": "印刷专用设备制造",
				"value": "3542"
			}, {
				"text": "制浆和造纸专用设备制造",
				"value": "3541"
			}],
			"text": "印刷、制药、日化及日用品生产专用设备制造",
			"value": "354"
		}, {
			"children": [{
				"text": "其他电子专用设备制造",
				"value": "3569"
			}, {
				"text": "电子元器件与机电组件设备制造",
				"value": "3563"
			}, {
				"text": "半导体器件专用设备制造",
				"value": "3562"
			}, {
				"text": "电工机械专用设备制造",
				"value": "3561"
			}],
			"text": "电子和电工机械专用设备制造",
			"value": "356"
		}, {
			"children": [{
				"text": "其他农、林、牧、渔业机械制造",
				"value": "3579"
			}, {
				"text": "棉花加工机械制造",
				"value": "3577"
			}, {
				"text": "农林牧渔机械配件制造",
				"value": "3576"
			}, {
				"text": "渔业机械制造",
				"value": "3575"
			}, {
				"text": "畜牧机械制造",
				"value": "3574"
			}, {
				"text": "营林及木竹采伐机械制造",
				"value": "3573"
			}, {
				"text": "机械化农业及园艺机具制造",
				"value": "3572"
			}, {
				"text": "拖拉机制造",
				"value": "3571"
			}],
			"text": "农、林、牧、渔专用机械制造",
			"value": "357"
		}, {
			"children": [{
				"text": "洗涤机械制造",
				"value": "3554"
			}, {
				"text": "缝制机械制造",
				"value": "3553"
			}, {
				"text": "皮革、毛皮及其制品加工专用设备制造",
				"value": "3552"
			}, {
				"text": "纺织专用设备制造",
				"value": "3551"
			}],
			"text": "纺织、服装和皮革加工专用设备制造",
			"value": "355"
		}, {
			"children": [{
				"text": "其他医疗设备及器械制造",
				"value": "3589"
			}, {
				"text": "眼镜制造",
				"value": "3587"
			}, {
				"text": "康复辅具制造",
				"value": "3586"
			}, {
				"text": "机械治疗及病房护理设备制造",
				"value": "3585"
			}, {
				"text": "医疗、外科及兽医用器械制造",
				"value": "3584"
			}, {
				"text": "医疗实验室及医用消毒设备和器具制造",
				"value": "3583"
			}, {
				"text": "口腔科用设备及器具制造",
				"value": "3582"
			}, {
				"text": "医疗诊断、监护及治疗设备制造",
				"value": "3581"
			}],
			"text": "医疗仪器设备及器械制造",
			"value": "358"
		}],
		"text": "专用设备制造业",
		"value": "35"
	}, {
		"children": [{
			"children": [{
				"text": "其他机械和设备修理业",
				"value": "4390"
			}],
			"text": "其他机械和设备修理业",
			"value": "439"
		}, {
			"children": [{
				"text": "仪器仪表修理",
				"value": "4360"
			}],
			"text": "仪器仪表修理",
			"value": "436"
		}, {
			"children": [{
				"text": "金属制品修理",
				"value": "4310"
			}],
			"text": "金属制品修理",
			"value": "431"
		}, {
			"children": [{
				"text": "铁路运输设备修理",
				"value": "4341"
			}, {
				"text": "船舶修理",
				"value": "4342"
			}, {
				"text": "航空航天器修理",
				"value": "4343"
			}, {
				"text": "其他运输设备修理",
				"value": "4349"
			}],
			"text": "铁路、船舶、航空航天等运输设备修理",
			"value": "434"
		}, {
			"children": [{
				"text": "专用设备修理",
				"value": "4330"
			}],
			"text": "专用设备修理",
			"value": "433"
		}, {
			"children": [{
				"text": "通用设备修理",
				"value": "4320"
			}],
			"text": "通用设备修理",
			"value": "432"
		}, {
			"children": [{
				"text": "电气设备修理",
				"value": "4350"
			}],
			"text": "电气设备修理",
			"value": "435"
		}],
		"text": "金属制品、机械和设备修理业",
		"value": "43"
	}, {
		"children": [{
			"children": [{
				"text": "汽车零部件及配件制造",
				"value": "3670"
			}],
			"text": "汽车零部件及配件制造",
			"value": "367"
		}, {
			"children": [{
				"text": "电车制造",
				"value": "3650"
			}],
			"text": "电车制造",
			"value": "365"
		}, {
			"children": [{
				"text": "汽车车身、挂车制造",
				"value": "3660"
			}],
			"text": "汽车车身、挂车制造",
			"value": "366"
		}, {
			"children": [{
				"text": "低速汽车制造",
				"value": "3640"
			}],
			"text": "低速汽车制造",
			"value": "364"
		}, {
			"children": [{
				"text": "汽车用发动机制造",
				"value": "3620"
			}],
			"text": "汽车用发动机制造",
			"value": "362"
		}, {
			"children": [{
				"text": "新能源车整车制造",
				"value": "3612"
			}, {
				"text": "汽柴油车整车制造",
				"value": "3611"
			}],
			"text": "汽车整车制造",
			"value": "361"
		}, {
			"children": [{
				"text": "改装汽车制造",
				"value": "3630"
			}],
			"text": "改装汽车制造",
			"value": "363"
		}],
		"text": "汽车制造业",
		"value": "36"
	}, {
		"children": [{
			"children": [{
				"text": "本册印制",
				"value": "2312"
			}, {
				"text": "书、报刊印刷",
				"value": "2311"
			}, {
				"text": "包装装潢及其他印刷",
				"value": "2319"
			}],
			"text": "印刷",
			"value": "231"
		}, {
			"children": [{
				"text": "装订及印刷相关服务",
				"value": "2320"
			}],
			"text": "装订及印刷相关服务",
			"value": "232"
		}, {
			"children": [{
				"text": "记录媒介复制",
				"value": "2330"
			}],
			"text": "记录媒介复制",
			"value": "233"
		}],
		"text": "印刷和记录媒介复制业",
		"value": "23"
	}, {
		"children": [{
			"children": [{
				"text": "人造纤维（纤维素纤维）制造",
				"value": "2812"
			}, {
				"text": "化纤浆粕制造",
				"value": "2811"
			}],
			"text": "纤维素纤维原料及纤维制造",
			"value": "281"
		}, {
			"children": [{
				"text": "腈纶纤维制造",
				"value": "2823"
			}, {
				"text": "涤纶纤维制造",
				"value": "2822"
			}, {
				"text": "锦纶纤维制造",
				"value": "2821"
			}, {
				"text": "其他合成纤维制造",
				"value": "2829"
			}, {
				"text": "氨纶纤维制造",
				"value": "2826"
			}, {
				"text": "丙纶纤维制造",
				"value": "2825"
			}, {
				"text": "维纶纤维制造",
				"value": "2824"
			}],
			"text": "合成纤维制造",
			"value": "282"
		}, {
			"children": [{
				"text": "生物基、淀粉基新材料制造",
				"value": "2832"
			}, {
				"text": "生物基化学纤维制造",
				"value": "2831"
			}],
			"text": "生物基材料制造",
			"value": "283"
		}],
		"text": "化学纤维制造业",
		"value": "28"
	}, {
		"children": [{
			"children": [{
				"text": "中药饮片加工",
				"value": "2730"
			}],
			"text": "中药饮片加工",
			"value": "273"
		}, {
			"children": [{
				"text": "药用辅料及包装材料",
				"value": "2780"
			}],
			"text": "药用辅料及包装材料",
			"value": "278"
		}, {
			"children": [{
				"text": "化学药品制剂制造",
				"value": "2720"
			}],
			"text": "化学药品制剂制造",
			"value": "272"
		}, {
			"children": [{
				"text": "兽用药品制造",
				"value": "2750"
			}],
			"text": "兽用药品制造",
			"value": "275"
		}, {
			"children": [{
				"text": "卫生材料及医药用品制造",
				"value": "2770"
			}],
			"text": "生物药品制品制造",
			"value": "277"
		}, {
			"children": [{
				"text": "中成药生产",
				"value": "2740"
			}],
			"text": "中成药生产",
			"value": "274"
		}, {
			"children": [{
				"text": "化学药品原料药制造",
				"value": "2710"
			}],
			"text": "化学药品原料药制造",
			"value": "271"
		}, {
			"children": [{
				"text": "基因工程药物和疫苗制造",
				"value": "2762"
			}, {
				"text": "生物药品制造",
				"value": "2761"
			}],
			"text": "生物药品制品制造",
			"value": "276"
		}],
		"text": "医药制造业",
		"value": "27"
	}, {
		"children": [{
			"children": [{
				"text": "其他水泥类似制品制造",
				"value": "3029"
			}, {
				"text": "轻质建筑材料制造",
				"value": "3024"
			}, {
				"text": "石棉水泥制品制造",
				"value": "3023"
			}, {
				"text": "砼结构构件制造",
				"value": "3022"
			}, {
				"text": "水泥制品制造",
				"value": "3021"
			}],
			"text": "石膏、水泥制品及类似制品制造",
			"value": "302"
		}, {
			"children": [{
				"text": "建筑陶瓷制品制造",
				"value": "3071"
			}, {
				"text": "其他陶瓷制品制造",
				"value": "3079"
			}, {
				"text": "园艺陶瓷制造",
				"value": "3076"
			}, {
				"text": "陈设艺术陶瓷制造",
				"value": "3075"
			}, {
				"text": "日用陶瓷制品制造",
				"value": "3074"
			}, {
				"text": "特种陶瓷制品制造",
				"value": "3073"
			}, {
				"text": "卫生陶瓷制品制造",
				"value": "3072"
			}],
			"text": "陶瓷制品制造",
			"value": "307"
		}, {
			"children": [{
				"text": "石灰和石膏制造",
				"value": "3012"
			}, {
				"text": "水泥制造",
				"value": "3011"
			}],
			"text": "水泥、石灰和石膏制造",
			"value": "301"
		}, {
			"children": [{
				"text": "石墨及碳素制品制造",
				"value": "3091"
			}, {
				"text": "其他非金属矿物制品制造",
				"value": "3099"
			}],
			"text": "石墨及其他非金属矿物制品制造",
			"value": "309"
		}, {
			"children": [{
				"text": "其他玻璃制品制造",
				"value": "3059"
			}, {
				"text": "制镜及类似品加工",
				"value": "3057"
			}, {
				"text": "玻璃保温容器制造",
				"value": "3056"
			}, {
				"text": "玻璃包装容器制造",
				"value": "3055"
			}, {
				"text": "日用玻璃制品制造",
				"value": "3054"
			}, {
				"text": "玻璃仪器制造",
				"value": "3053"
			}, {
				"text": "光学玻璃制造",
				"value": "3052"
			}, {
				"text": "技术玻璃制品制造",
				"value": "3051"
			}],
			"text": "玻璃制品制造",
			"value": "305"
		}, {
			"children": [{
				"text": "其他玻璃制造",
				"value": "3049"
			}, {
				"text": "特种玻璃制造",
				"value": "3042"
			}, {
				"text": "平板玻璃制造",
				"value": "3041"
			}],
			"text": "玻璃制造",
			"value": "304"
		}, {
			"children": [{
				"text": "玻璃纤维增强塑料制品制造",
				"value": "3062"
			}, {
				"text": "玻璃纤维及制品制造",
				"value": "3061"
			}],
			"text": "玻璃纤维和玻璃纤维增强塑料制品制造",
			"value": "306"
		}, {
			"children": [{
				"text": "云母制品制造",
				"value": "3082"
			}, {
				"text": "石棉制品制造",
				"value": "3081"
			}, {
				"text": "耐火陶瓷制品及其他耐火材料制造",
				"value": "3089"
			}],
			"text": "耐火材料制品制造",
			"value": "308"
		}, {
			"children": [{
				"text": "其他建筑材料制造",
				"value": "3039"
			}, {
				"text": "隔热和隔音材料制造",
				"value": "3034"
			}, {
				"text": "防水建筑材料制造",
				"value": "3033"
			}, {
				"text": "建筑用石加工",
				"value": "3032"
			}, {
				"text": "粘土砖瓦及建筑砌块制造",
				"value": "3031"
			}],
			"text": "砖瓦、石材等建筑材料制造",
			"value": "303"
		}],
		"text": "非金属矿物制品业",
		"value": "30"
	}, {
		"children": [{
			"children": [{
				"text": "金属家具制造",
				"value": "2130"
			}],
			"text": "金属家具制造",
			"value": "213"
		}, {
			"children": [{
				"text": "其他家具制造",
				"value": "2190"
			}],
			"text": "其他家具制造",
			"value": "219"
		}, {
			"children": [{
				"text": "塑料家具制造",
				"value": "2140"
			}],
			"text": "塑料家具制造",
			"value": "214"
		}, {
			"children": [{
				"text": "竹、藤家具制造",
				"value": "2120"
			}],
			"text": "竹、藤家具制造",
			"value": "212"
		}, {
			"children": [{
				"text": "木质家具制造",
				"value": "2110"
			}],
			"text": "木质家具制造",
			"value": "211"
		}],
		"text": "家具制造业",
		"value": "21"
	}, {
		"children": [{
			"children": [{
				"text": "气压动力机械及元件制造",
				"value": "3446"
			}, {
				"text": "液力动力机械元件制造",
				"value": "3445"
			}, {
				"text": "液压动力机械及元件制造",
				"value": "3444"
			}, {
				"text": "阀门和旋塞制造",
				"value": "3443"
			}, {
				"text": "气体压缩机械制造",
				"value": "3442"
			}, {
				"text": "泵及真空设备制造",
				"value": "3441"
			}],
			"text": "泵、阀门、压缩机及类似机械制造",
			"value": "344"
		}, {
			"children": [{
				"text": "其他通用零部件制造",
				"value": "3489"
			}, {
				"text": "机械零部件加工",
				"value": "3484"
			}, {
				"text": "弹簧制造",
				"value": "3483"
			}, {
				"text": "紧固件制造",
				"value": "3482"
			}, {
				"text": "金属密封件制造",
				"value": "3481"
			}],
			"text": "通用零部件制造",
			"value": "348"
		}, {
			"children": [{
				"text": "其他传动部件制造",
				"value": "3459"
			}, {
				"text": "齿轮及齿轮减、变速箱制造",
				"value": "3453"
			}, {
				"text": "滑动轴承制造",
				"value": "3452"
			}, {
				"text": "滚动轴承制造",
				"value": "3451"
			}],
			"text": "轴承、齿轮和传动部件制造",
			"value": "345"
		}, {
			"children": [{
				"text": "包装专用设备制造",
				"value": "3467"
			}, {
				"text": "喷枪及类似器具制造",
				"value": "3466"
			}, {
				"text": "风动和电动工具制造",
				"value": "3465"
			}, {
				"text": "制冷、空调设备制造",
				"value": "3464"
			}, {
				"text": "气体、液体分离及纯净设备制造",
				"value": "3463"
			}, {
				"text": "风机、风扇制造",
				"value": "3462"
			}, {
				"text": "烘炉、熔炉及电炉制造",
				"value": "3461"
			}],
			"text": "烘炉、风机、包装等设备制造",
			"value": "346"
		}, {
			"children": [{
				"text": "其他文化、办公用机械制造",
				"value": "3479"
			}, {
				"text": "计算器及货币专用设备制造",
				"value": "3475"
			}, {
				"text": "复印和胶印设备制造",
				"value": "3474"
			}, {
				"text": "照相机及器材制造",
				"value": "3473"
			}, {
				"text": "幻灯及投影设备制造",
				"value": "3472"
			}, {
				"text": "电影机械制造",
				"value": "3471"
			}],
			"text": "文化、办公用机械制造",
			"value": "347"
		}, {
			"children": [{
				"text": "其他未列明通用设备制造业",
				"value": "3499"
			}, {
				"text": "增材制造装备制造",
				"value": "3493"
			}, {
				"text": "特殊作业机器人制造",
				"value": "3492"
			}, {
				"text": "工业机器人制造",
				"value": "3491"
			}],
			"text": "其他通用设备制造业",
			"value": "349"
		}, {
			"children": [{
				"text": "风能原动设备制造",
				"value": "3415"
			}, {
				"text": "水轮机及辅机制造",
				"value": "3414"
			}, {
				"text": "汽轮机及辅机制造",
				"value": "3413"
			}, {
				"text": "内燃机及配件制造",
				"value": "3412"
			}, {
				"text": "锅炉及辅助设备制造",
				"value": "3411"
			}, {
				"text": "其他原动设备制造",
				"value": "3419"
			}],
			"text": "锅炉及原动设备制造",
			"value": "341"
		}, {
			"children": [{
				"text": "机床功能部件及附件制造",
				"value": "3425"
			}, {
				"text": "金属切割及焊接设备制造",
				"value": "3424"
			}, {
				"text": "铸造机械制造",
				"value": "3423"
			}, {
				"text": "金属成形机床制造",
				"value": "3422"
			}, {
				"text": "金属切削机床制造",
				"value": "3421"
			}, {
				"text": "其他金属加工机械制造",
				"value": "3429"
			}],
			"text": "金属加工机械制造",
			"value": "342"
		}, {
			"children": [{
				"text": "其他物料搬运设备制造",
				"value": "3439"
			}, {
				"text": "机械式停车设备制造",
				"value": "3437"
			}, {
				"text": "客运索道制造",
				"value": "3436"
			}, {
				"text": "电梯、自动扶梯及升降机制造",
				"value": "3435"
			}, {
				"text": "连续搬运设备制造",
				"value": "3434"
			}, {
				"text": "生产专用车辆制造",
				"value": "3433"
			}, {
				"text": "生产专用起重机制造",
				"value": "3432"
			}, {
				"text": "轻小型起重设备制造",
				"value": "3431"
			}],
			"text": "物料搬运设备制造",
			"value": "343"
		}],
		"text": "通用设备制造业",
		"value": "34"
	}, {
		"children": [{
			"children": [{
				"text": "其他稀有金属冶炼",
				"value": "3239"
			}, {
				"text": "稀土金属冶炼",
				"value": "3232"
			}, {
				"text": "钨钼冶炼",
				"value": "3231"
			}],
			"text": "稀有稀土金属冶炼",
			"value": "323"
		}, {
			"children": [{
				"text": "其他贵金属冶炼",
				"value": "3229"
			}, {
				"text": "银冶炼",
				"value": "3222"
			}, {
				"text": "金冶炼",
				"value": "3221"
			}],
			"text": "贵金属冶炼",
			"value": "322"
		}, {
			"children": [{
				"text": "有色金属合金制造",
				"value": "3240"
			}],
			"text": "有色金属合金制造",
			"value": "324"
		}, {
			"children": [{
				"text": "其他常用有色金属冶炼",
				"value": "3219"
			}, {
				"text": "硅冶炼",
				"value": "3218"
			}, {
				"text": "镁冶炼",
				"value": "3217"
			}, {
				"text": "铝冶炼",
				"value": "3216"
			}, {
				"text": "锑冶炼",
				"value": "3215"
			}, {
				"text": "锡冶炼",
				"value": "3214"
			}, {
				"text": "镍钴冶炼",
				"value": "3213"
			}, {
				"text": "铅锌冶炼",
				"value": "3212"
			}, {
				"text": "铜冶炼",
				"value": "3211"
			}],
			"text": "常用有色金属冶炼",
			"value": "321"
		}, {
			"children": [{
				"text": "其他有色金属压延加工",
				"value": "3259"
			}, {
				"text": "稀有稀土金属压延加工",
				"value": "3254"
			}, {
				"text": "贵金属压延加工",
				"value": "3253"
			}, {
				"text": "铝压延加工",
				"value": "3252"
			}, {
				"text": "铜压延加工",
				"value": "3251"
			}],
			"text": "有色金属压延加工",
			"value": "325"
		}],
		"text": "有色金属冶炼和压延加工业",
		"value": "32"
	}, {
		"children": [{
			"children": [{
				"text": "其他电池制造",
				"value": "3849"
			}, {
				"text": "锂离子电池制造",
				"value": "3841"
			}, {
				"text": "镍氢电池制造",
				"value": "3842"
			}, {
				"text": "铅蓄电池制造",
				"value": "3843"
			}, {
				"text": "锌锰电池制造",
				"value": "3844"
			}],
			"text": "电池制造",
			"value": "384"
		}, {
			"children": [{
				"text": "电光源制造",
				"value": "3871"
			}, {
				"text": "照明灯具制造",
				"value": "3872"
			}, {
				"text": "舞台及场地用灯制造",
				"value": "3873"
			}, {
				"text": "智能照明器具制造",
				"value": "3874"
			}, {
				"text": "灯用电器附件及其他照明器具制造",
				"value": "3879"
			}],
			"text": "照明器具制造",
			"value": "387"
		}, {
			"children": [{
				"text": "其他电机制造",
				"value": "3819"
			}, {
				"text": "发电机及发电机组制造",
				"value": "3811"
			}, {
				"text": "电动机制造",
				"value": "3812"
			}, {
				"text": "微特电机及组件制造",
				"value": "3813"
			}],
			"text": "电机制造",
			"value": "381"
		}, {
			"children": [{
				"text": "光伏设备及元器件制造",
				"value": "3825"
			}, {
				"text": "其他输配电及控制设备制造",
				"value": "3829"
			}, {
				"text": "变压器、整流器和电感器制造",
				"value": "3821"
			}, {
				"text": "电容器及其配套设备制造",
				"value": "3822"
			}, {
				"text": "配电开关控制设备制造",
				"value": "3823"
			}, {
				"text": "电力电子元器件制造",
				"value": "3824"
			}],
			"text": "输配电及控制设备制造",
			"value": "382"
		}, {
			"children": [{
				"text": "电气信号设备装置制造",
				"value": "3891"
			}, {
				"text": "其他未列明电气机械及器材制造",
				"value": "3899"
			}],
			"text": "其他电气机械及器材制造",
			"value": "389"
		}, {
			"children": [{
				"text": "其他非电力家用器具制造",
				"value": "3869"
			}, {
				"text": "燃气及类似能源家用器具制造",
				"value": "3861"
			}, {
				"text": "太阳能器具制造",
				"value": "3862"
			}],
			"text": "非电力家用器具制造",
			"value": "386"
		}, {
			"children": [{
				"text": "其他电工器材制造",
				"value": "3839"
			}, {
				"text": "电线、电缆制造",
				"value": "3831"
			}, {
				"text": "光纤制造",
				"value": "3832"
			}, {
				"text": "光缆制造",
				"value": "3833"
			}, {
				"text": "绝缘制品制造",
				"value": "3834"
			}],
			"text": "电线、电缆、光缆及电工器材制造",
			"value": "383"
		}, {
			"children": [{
				"text": "其他家用电力器具制造",
				"value": "3859"
			}, {
				"text": "家用制冷电器具制造",
				"value": "3851"
			}, {
				"text": "家用空气调节器制造",
				"value": "3852"
			}, {
				"text": "家用通风电器具制造",
				"value": "3853"
			}, {
				"text": "家用厨房电器具制造",
				"value": "3854"
			}, {
				"text": "家用清洁卫生电器具制造",
				"value": "3855"
			}, {
				"text": "家用美容、保健护理电器具制造",
				"value": "3856"
			}, {
				"text": "家用电力器具专用配件制造",
				"value": "3857"
			}],
			"text": "家用电力器具制造",
			"value": "385"
		}],
		"text": "电气机械和器材制造业",
		"value": "38"
	}, {
		"children": [{
			"children": [{
				"text": "精制茶加工",
				"value": "1530"
			}],
			"text": "精制茶加工",
			"value": "153"
		}, {
			"children": [{
				"text": "固体饮料制造",
				"value": "1525"
			}, {
				"text": "含乳饮料和植物蛋白饮料制造",
				"value": "1524"
			}, {
				"text": "果菜汁及果菜汁饮料制造",
				"value": "1523"
			}, {
				"text": "瓶（罐）装饮用水制造",
				"value": "1522"
			}, {
				"text": "碳酸饮料制造",
				"value": "1521"
			}, {
				"text": "茶饮料及其他饮料制造",
				"value": "1529"
			}],
			"text": "饮料制造",
			"value": "152"
		}, {
			"children": [{
				"text": "黄酒制造",
				"value": "1514"
			}, {
				"text": "啤酒制造",
				"value": "1513"
			}, {
				"text": "白酒制造",
				"value": "1512"
			}, {
				"text": "酒精制造",
				"value": "1511"
			}, {
				"text": "其他酒制造",
				"value": "1519"
			}, {
				"text": "葡萄酒制造",
				"value": "1515"
			}],
			"text": "酒的制造",
			"value": "151"
		}],
		"text": "酒、饮料和精制茶制造业",
		"value": "15"
	}, {
		"children": [{
			"children": [{
				"text": "其他建筑、安全用金属制品制造",
				"value": "3359"
			}, {
				"text": "安全、消防用金属制品制造",
				"value": "3353"
			}, {
				"text": "建筑装饰及水暖管道零件制造",
				"value": "3352"
			}, {
				"text": "建筑、家具用金属配件制造",
				"value": "3351"
			}],
			"text": "建筑、安全用金属制品制造",
			"value": "335"
		}, {
			"children": [{
				"text": "金属门窗制造",
				"value": "3312"
			}, {
				"text": "金属结构制造",
				"value": "3311"
			}],
			"text": "结构性金属制品制造",
			"value": "331"
		}, {
			"children": [{
				"text": "金属包装容器及材料制造",
				"value": "3333"
			}, {
				"text": "金属压力容器制造",
				"value": "3332"
			}, {
				"text": "集装箱制造",
				"value": "3331"
			}],
			"text": "集装箱及金属包装容器制造",
			"value": "333"
		}, {
			"children": [{
				"text": "金属表面处理及热处理加工",
				"value": "3360"
			}],
			"text": "金属表面处理及热处理加工",
			"value": "336"
		}, {
			"children": [{
				"text": "其他金属制日用品制造",
				"value": "3389"
			}, {
				"text": "金属制卫生器具制造",
				"value": "3383"
			}, {
				"text": "金属制餐具和器皿制造",
				"value": "3382"
			}, {
				"text": "金属制厨房用器具制造",
				"value": "3381"
			}],
			"text": "金属制日用品制造",
			"value": "338"
		}, {
			"children": [{
				"text": "其他未列明金属制品制造",
				"value": "3399"
			}, {
				"text": "交通及公共管理用金属标牌制造",
				"value": "3394"
			}, {
				"text": "锻件及粉末冶金制品制造",
				"value": "3393"
			}, {
				"text": "有色金属铸造",
				"value": "3392"
			}, {
				"text": "黑色金属铸造",
				"value": "3391"
			}],
			"text": "铸造及其他金属制品制造",
			"value": "339"
		}, {
			"children": [{
				"text": "金属丝绳及其制品制造",
				"value": "3340"
			}],
			"text": "金属丝绳及其制品制造",
			"value": "334"
		}, {
			"children": [{
				"text": "搪瓷日用品及其他搪瓷制品制造",
				"value": "3379"
			}, {
				"text": "搪瓷卫生洁具制造",
				"value": "3373"
			}, {
				"text": "建筑装饰搪瓷制品制造",
				"value": "3372"
			}, {
				"text": "生产专用搪瓷制品制造",
				"value": "3371"
			}],
			"text": "搪瓷制品制造",
			"value": "337"
		}, {
			"children": [{
				"text": "其他金属工具制造",
				"value": "3329"
			}, {
				"text": "刀剪及类似日用金属工具制造",
				"value": "3324"
			}, {
				"text": "农用及园林用金属工具制造",
				"value": "3323"
			}, {
				"text": "手工具制造",
				"value": "3322"
			}, {
				"text": "切削工具制造",
				"value": "3321"
			}],
			"text": "金属工具制造",
			"value": "332"
		}],
		"text": "金属制品业",
		"value": "33"
	}, {
		"children": [{
			"children": [{
				"text": "非木竹浆制造",
				"value": "2212"
			}, {
				"text": "木竹浆制造",
				"value": "2211"
			}],
			"text": "纸浆制造",
			"value": "221"
		}, {
			"children": [{
				"text": "加工纸制造",
				"value": "2223"
			}, {
				"text": "手工纸制造",
				"value": "2222"
			}, {
				"text": "机制纸及纸板制造",
				"value": "2221"
			}],
			"text": "造纸",
			"value": "222"
		}, {
			"children": [{
				"text": "其他纸制品制造",
				"value": "2239"
			}, {
				"text": "纸和纸板容器制造",
				"value": "2231"
			}],
			"text": "纸制品制造",
			"value": "223"
		}],
		"text": "造纸和纸制品业",
		"value": "22"
	}, {
		"children": [{
			"children": [{
				"text": "橡胶鞋制造",
				"value": "1954"
			}, {
				"text": "塑料鞋制造",
				"value": "1953"
			}, {
				"text": "皮鞋制造",
				"value": "1952"
			}, {
				"text": "纺织面料鞋制造",
				"value": "1951"
			}, {
				"text": "其他制鞋业",
				"value": "1959"
			}],
			"text": "制鞋业",
			"value": "195"
		}, {
			"children": [{
				"text": "毛皮服装加工",
				"value": "1932"
			}, {
				"text": "毛皮鞣制加工",
				"value": "1931"
			}, {
				"text": "其他毛皮制品加工",
				"value": "1939"
			}],
			"text": "毛皮鞣制及制品加工",
			"value": "193"
		}, {
			"children": [{
				"text": "皮革服装制造",
				"value": "1921"
			}, {
				"text": "其他皮革制品制造",
				"value": "1929"
			}, {
				"text": "皮手套及皮装饰制品制造",
				"value": "1923"
			}, {
				"text": "皮箱、包（袋）制造",
				"value": "1922"
			}],
			"text": "皮革制品制造",
			"value": "192"
		}, {
			"children": [{
				"text": "羽毛（绒）制品加工",
				"value": "1942"
			}, {
				"text": "羽毛（绒）加工",
				"value": "1941"
			}],
			"text": "羽毛（绒）加工及制品制造",
			"value": "194"
		}, {
			"children": [{
				"text": "皮革鞣制加工",
				"value": "1910"
			}],
			"text": "皮革鞣制加工",
			"value": "191"
		}],
		"text": "皮革、毛皮、羽毛及其制品和制鞋业",
		"value": "19"
	}, {
		"children": [{
			"children": [{
				"text": "铁合金冶炼",
				"value": "3140"
			}],
			"text": "铁合金冶炼",
			"value": "314"
		}, {
			"children": [{
				"text": "炼铁",
				"value": "3110"
			}],
			"text": "炼铁",
			"value": "311"
		}, {
			"children": [{
				"text": "炼钢",
				"value": "3120"
			}],
			"text": "炼钢",
			"value": "312"
		}, {
			"children": [{
				"text": "钢压延加工",
				"value": "3130"
			}],
			"text": "钢压延加工",
			"value": "313"
		}],
		"text": "黑色金属冶炼和压延加工业",
		"value": "31"
	}, {
		"children": [{
			"children": [{
				"text": "卷烟制造",
				"value": "1620"
			}],
			"text": "卷烟制造",
			"value": "162"
		}, {
			"children": [{
				"text": "其他烟草制品制造",
				"value": "1690"
			}],
			"text": "其他烟草制品制造",
			"value": "169"
		}, {
			"children": [{
				"text": "烟叶复烤",
				"value": "1610"
			}],
			"text": "烟叶复烤",
			"value": "161"
		}],
		"text": "烟草制品业",
		"value": "16"
	}, {
		"children": [{
			"children": [{
				"text": "制糖业",
				"value": "1340"
			}],
			"text": "制糖业",
			"value": "134"
		}, {
			"children": [{
				"text": "杂粮加工",
				"value": "1314"
			}, {
				"text": "玉米加工",
				"value": "1313"
			}, {
				"text": "小麦加工",
				"value": "1312"
			}, {
				"text": "稻谷加工",
				"value": "1311"
			}, {
				"text": "其他谷物磨制",
				"value": "1319"
			}],
			"text": "谷物磨制",
			"value": "131"
		}, {
			"children": [{
				"text": "宠物饲料加工",
				"value": "1321"
			}, {
				"text": "其他饲料加工",
				"value": "1329"
			}],
			"text": "饲料加工",
			"value": "132"
		}, {
			"children": [{
				"text": "其他水产品加工",
				"value": "1369"
			}, {
				"text": "鱼油提取及制品制造",
				"value": "1363"
			}, {
				"text": "鱼糜制品及水产品干腌制加工",
				"value": "1362"
			}, {
				"text": "水产品冷冻加工",
				"value": "1361"
			}],
			"text": "水产品加工",
			"value": "136"
		}, {
			"children": [{
				"text": "水果和坚果加工",
				"value": "1373"
			}, {
				"text": "食用菌加工",
				"value": "1372"
			}, {
				"text": "蔬菜加工",
				"value": "1371"
			}],
			"text": "蔬菜、菌类、水果和坚果加工",
			"value": "137"
		}, {
			"children": [{
				"text": "其他未列明农副食品加工",
				"value": "1399"
			}, {
				"text": "蛋品加工",
				"value": "1393"
			}, {
				"text": "豆制品制造",
				"value": "1392"
			}, {
				"text": "淀粉及淀粉制品制造",
				"value": "1391"
			}],
			"text": "其他农副食品加工",
			"value": "139"
		}, {
			"children": [{
				"text": "非食用植物油加工",
				"value": "1332"
			}, {
				"text": "食用植物油加工",
				"value": "1331"
			}],
			"text": "植物油加工",
			"value": "133"
		}, {
			"children": [{
				"text": "肉制品及副产品加工",
				"value": "1353"
			}, {
				"text": "禽类屠宰",
				"value": "1352"
			}, {
				"text": "牲畜屠宰",
				"value": "1351"
			}],
			"text": "屠宰及肉类加工",
			"value": "135"
		}],
		"text": "农副食品加工业",
		"value": "13"
	}, {
		"children": [{
			"children": [{
				"text": "服饰制造",
				"value": "1830"
			}],
			"text": "服饰制造",
			"value": "183"
		}, {
			"children": [{
				"text": "运动休闲针织服装制造",
				"value": "1821"
			}, {
				"text": "其他针织或钩针编织服装制造",
				"value": "1829"
			}],
			"text": "针织或钩针编织服装制造",
			"value": "182"
		}, {
			"children": [{
				"text": "运动机织服装制造",
				"value": "1811"
			}, {
				"text": "其他机织服装制造",
				"value": "1819"
			}],
			"text": "机织服装制造",
			"value": "181"
		}],
		"text": "纺织服装、服饰业",
		"value": "18"
	}, {
		"children": [{
			"children": [{
				"text": "煤制品制造",
				"value": "2524"
			}, {
				"text": "煤制液体燃料生产",
				"value": "2523"
			}, {
				"text": "煤制合成气生产",
				"value": "2522"
			}, {
				"text": "炼焦",
				"value": "2521"
			}, {
				"text": "其他煤炭加工",
				"value": "2529"
			}],
			"text": "煤炭加工",
			"value": "252"
		}, {
			"children": [{
				"text": "生物质致密成型燃料加工",
				"value": "2542"
			}, {
				"text": "生物质液体燃料生产",
				"value": "2541"
			}],
			"text": "生物质燃料加工",
			"value": "254"
		}, {
			"children": [{
				"text": "核燃料加工",
				"value": "2530"
			}],
			"text": "核燃料加工",
			"value": "253"
		}, {
			"children": [{
				"text": "原油加工及石油制品制造",
				"value": "2511"
			}, {
				"text": "其他原油制造",
				"value": "2519"
			}],
			"text": "精炼石油产品制造",
			"value": "251"
		}],
		"text": "石油、煤炭及其他燃料加工业",
		"value": "25"
	}, {
		"children": [{
			"children": [{
				"text": "密封用填料及类似品制造",
				"value": "2646"
			}, {
				"text": "染料制造",
				"value": "2645"
			}, {
				"text": "工艺美术颜料制造",
				"value": "2644"
			}, {
				"text": "工业颜料制造",
				"value": "2643"
			}, {
				"text": "油墨及类似产品制造",
				"value": "2642"
			}, {
				"text": "涂料制造",
				"value": "2641"
			}],
			"text": "涂料、油墨、颜料及类似产品制造",
			"value": "264"
		}, {
			"children": [{
				"text": "其他专用化学产品制造",
				"value": "2669"
			}, {
				"text": "动物胶制造",
				"value": "2667"
			}, {
				"text": "环境污染处理专用药剂材料制造",
				"value": "2666"
			}, {
				"text": "医学生产用信息化学品制造",
				"value": "2665"
			}, {
				"text": "文化用信息化学品制造",
				"value": "2664"
			}, {
				"text": "林产化学产品制造",
				"value": "2663"
			}, {
				"text": "专项化学用品制造",
				"value": "2662"
			}, {
				"text": "化学试剂和助剂制造",
				"value": "2661"
			}],
			"text": "专用化学产品制造",
			"value": "266"
		}, {
			"children": [{
				"text": "生物化学农药及微生物农药制造",
				"value": "2632"
			}, {
				"text": "化学农药制造",
				"value": "2631"
			}],
			"text": "农药制造",
			"value": "263"
		}, {
			"children": [{
				"text": "有机肥料及微生物肥料制造",
				"value": "2625"
			}, {
				"text": "复混肥料制造",
				"value": "2624"
			}, {
				"text": "钾肥制造",
				"value": "2623"
			}, {
				"text": "磷肥制造",
				"value": "2622"
			}, {
				"text": "氮肥制造",
				"value": "2621"
			}, {
				"text": "其他肥料制造",
				"value": "2629"
			}],
			"text": "肥料制造",
			"value": "262"
		}, {
			"children": [{
				"text": "焰火、鞭炮产品制造",
				"value": "2672"
			}, {
				"text": "炸药及火工产品制造",
				"value": "2671"
			}],
			"text": "炸药、火工及焰火产品制造",
			"value": "267"
		}, {
			"children": [{
				"text": "有机化学原料制造",
				"value": "2614"
			}, {
				"text": "无机盐制造",
				"value": "2613"
			}, {
				"text": "无机碱制造",
				"value": "2612"
			}, {
				"text": "无机酸制造",
				"value": "2611"
			}, {
				"text": "其他基础化学原料制造",
				"value": "2619"
			}],
			"text": "基础化学原料制造",
			"value": "261"
		}, {
			"children": [{
				"text": "合成纤维单（聚合）体制造",
				"value": "2653"
			}, {
				"text": "合成橡胶制造",
				"value": "2652"
			}, {
				"text": "初级形态塑料及合成树脂制造",
				"value": "2651"
			}, {
				"text": "其他合成材料制造",
				"value": "2659"
			}],
			"text": "合成材料制造",
			"value": "265"
		}, {
			"children": [{
				"text": "其他日用化学产品制造",
				"value": "2689"
			}, {
				"text": "香料、香精制造",
				"value": "2684"
			}, {
				"text": "口腔清洁用品制造",
				"value": "2683"
			}, {
				"text": "化妆品制造",
				"value": "2682"
			}, {
				"text": "肥皂及洗涤剂制造",
				"value": "2681"
			}],
			"text": "日用化学产品制造",
			"value": "268"
		}],
		"text": "化学原料和化学制品制造业",
		"value": "26"
	}, {
		"children": [{
			"children": [{
				"text": "蜜饯制作",
				"value": "1422"
			}, {
				"text": "糖果、巧克力制造",
				"value": "1421"
			}],
			"text": "糖果、巧克力及蜜饯制造",
			"value": "142"
		}, {
			"children": [{
				"text": "糕点、面包制造",
				"value": "1411"
			}, {
				"text": "饼干及其他焙烤食品制造",
				"value": "1419"
			}],
			"text": "焙烤食品制造",
			"value": "141"
		}, {
			"children": [{
				"text": "其他罐头食品制造",
				"value": "1459"
			}, {
				"text": "蔬菜、水果罐头制造",
				"value": "1453"
			}, {
				"text": "水产品罐头制造",
				"value": "1452"
			}, {
				"text": "肉、禽类罐头制造",
				"value": "1451"
			}],
			"text": "罐头食品制造",
			"value": "145"
		}, {
			"children": [{
				"text": "其他未列明食品制造",
				"value": "1499"
			}, {
				"text": "食品及饲料添加剂制造",
				"value": "1495"
			}, {
				"text": "盐加工",
				"value": "1494"
			}, {
				"text": "冷冻饮品及食用冰制造",
				"value": "1493"
			}, {
				"text": "保健食品制造",
				"value": "1492"
			}, {
				"text": "营养食品制造",
				"value": "1491"
			}],
			"text": "其他食品制造",
			"value": "149"
		}, {
			"children": [{
				"text": "其他调味品、发酵制品制造",
				"value": "1469"
			}, {
				"text": "酱油、食醋及类似制品制造",
				"value": "1462"
			}, {
				"text": "味精制造",
				"value": "1461"
			}],
			"text": "调味品、发酵制品制造",
			"value": "146"
		}, {
			"children": [{
				"text": "乳粉制造",
				"value": "1442"
			}, {
				"text": "液体乳制造",
				"value": "1441"
			}, {
				"text": "其他乳制品制造",
				"value": "1449"
			}],
			"text": "乳制品制造",
			"value": "144"
		}, {
			"children": [{
				"text": "方便面制造",
				"value": "1433"
			}, {
				"text": "速冻食品制造",
				"value": "1432"
			}, {
				"text": "米、面制品制造",
				"value": "1431"
			}, {
				"text": "其他方便食品制造",
				"value": "1439"
			}],
			"text": "方便食品制造",
			"value": "143"
		}],
		"text": "食品制造业",
		"value": "14"
	}, {
		"children": [{
			"children": [{
				"text": "衡器制造",
				"value": "4050"
			}],
			"text": "衡器制造",
			"value": "405"
		}, {
			"children": [{
				"text": "环境监测专用仪器仪表制造",
				"value": "4021"
			}, {
				"text": "运输设备及生产用计数仪表制造",
				"value": "4022"
			}, {
				"text": "导航、测绘、气象及海洋专用仪器制造",
				"value": "4023"
			}, {
				"text": "农林牧渔专用仪器仪表制造",
				"value": "4024"
			}, {
				"text": "地质勘探和地震专用仪器制造",
				"value": "4025"
			}, {
				"text": "教学专用仪器制造",
				"value": "4026"
			}, {
				"text": "核子及核辐射测量仪器制造",
				"value": "4027"
			}, {
				"text": "电子测量仪器制造",
				"value": "4028"
			}, {
				"text": "其他专用仪器制造",
				"value": "4029"
			}],
			"text": "专用仪器仪表制造",
			"value": "402"
		}, {
			"children": [{
				"text": "钟表与计时仪器制造",
				"value": "4030"
			}],
			"text": "钟表与计时仪器制造",
			"value": "403"
		}, {
			"children": [{
				"text": "光学仪器制造",
				"value": "4040"
			}],
			"text": "光学仪器制造",
			"value": "404"
		}, {
			"children": [{
				"text": "工业自动控制系统装置制造",
				"value": "4011"
			}, {
				"text": "电工仪器仪表制造",
				"value": "4012"
			}, {
				"text": "绘图、计算及测量仪器制造",
				"value": "4013"
			}, {
				"text": "实验分析仪器制造",
				"value": "4014"
			}, {
				"text": "试验机制造",
				"value": "4015"
			}, {
				"text": "供应用仪器仪表制造",
				"value": "4016"
			}, {
				"text": "其他通用仪器制造",
				"value": "4019"
			}],
			"text": "通用仪器仪表制造",
			"value": "401"
		}, {
			"children": [{
				"text": "其他仪器仪表制造业",
				"value": "4090"
			}],
			"text": "其他仪器仪表制造业",
			"value": "409"
		}],
		"text": "仪器仪表制造业",
		"value": "40"
	}, {
		"children": [{
			"children": [{
				"text": "丝印染精加工",
				"value": "1743"
			}, {
				"text": "绢纺和丝织加工",
				"value": "1742"
			}, {
				"text": "缫丝加工",
				"value": "1741"
			}],
			"text": "丝绢纺织及印染精加工",
			"value": "174"
		}, {
			"children": [{
				"text": "棉织造加工",
				"value": "1712"
			}, {
				"text": "棉纺纱加工",
				"value": "1711"
			}, {
				"text": "棉印染精加工",
				"value": "1713"
			}],
			"text": "棉纺织及印染精加工",
			"value": "171"
		}, {
			"children": [{
				"text": "窗帘、布艺类产品制造",
				"value": "1773"
			}, {
				"text": "毛巾类制品制造",
				"value": "1772"
			}, {
				"text": "床上用品制造",
				"value": "1771"
			}, {
				"text": "其他家用纺织制成品制造",
				"value": "1779"
			}],
			"text": "家用纺织制成品制造",
			"value": "177"
		}, {
			"children": [{
				"text": "其他产业用纺织制成品制造",
				"value": "1789"
			}, {
				"text": "篷、帆布制造",
				"value": "1784"
			}, {
				"text": "纺织带和帘子布制造",
				"value": "1783"
			}, {
				"text": "绳、索、缆制造",
				"value": "1782"
			}, {
				"text": "非织造布制造",
				"value": "1781"
			}],
			"text": "产业用纺织制成品制造",
			"value": "178"
		}, {
			"children": [{
				"text": "麻染整精加工",
				"value": "1733"
			}, {
				"text": "麻织造加工",
				"value": "1732"
			}, {
				"text": "麻纤维纺前加工和纺纱",
				"value": "1731"
			}],
			"text": "麻纺织及染整精加工",
			"value": "173"
		}, {
			"children": [{
				"text": "针织或钩针编织品制造",
				"value": "1763"
			}, {
				"text": "针织或钩针编织物印染精加工",
				"value": "1762"
			}, {
				"text": "针织或钩针编织物织造",
				"value": "1761"
			}],
			"text": "针织或钩针编织物及其制品制造",
			"value": "176"
		}, {
			"children": [{
				"text": "毛染整精加工",
				"value": "1723"
			}, {
				"text": "毛织造加工",
				"value": "1722"
			}, {
				"text": "毛条和毛纱线加工",
				"value": "1721"
			}],
			"text": "毛纺织及染整精加工",
			"value": "172"
		}, {
			"children": [{
				"text": "化纤织物染整精加工",
				"value": "1752"
			}, {
				"text": "化纤织造加工",
				"value": "1751"
			}],
			"text": "化纤织造及印染精加工",
			"value": "175"
		}],
		"text": "纺织业",
		"value": "17"
	}, {
		"children": [{
			"children": [{
				"text": "电阻电容电感元件制造",
				"value": "3981"
			}, {
				"text": "电子电路制造",
				"value": "3982"
			}, {
				"text": "敏感元件及传感器制造",
				"value": "3983"
			}, {
				"text": "电声器件及零件制造",
				"value": "3984"
			}, {
				"text": "电子专用材料制造",
				"value": "3985"
			}, {
				"text": "其他电子元件制造",
				"value": "3989"
			}],
			"text": "电子元件及电子专用材料制造",
			"value": "398"
		}, {
			"children": [{
				"text": "计算机外围设备制造",
				"value": "3913"
			}, {
				"text": "工业控制计算机及系统制造",
				"value": "3914"
			}, {
				"text": "信息安全设备制造",
				"value": "3915"
			}, {
				"text": "其他计算机制造",
				"value": "3919"
			}, {
				"text": "计算机整机制造",
				"value": "3911"
			}, {
				"text": "计算机零部件制造",
				"value": "3912"
			}],
			"text": "计算机制造",
			"value": "391"
		}, {
			"children": [{
				"text": "应用电视设备及其他广播电视设备制造",
				"value": "3939"
			}, {
				"text": "广播电视节目制作及发射设备制造",
				"value": "3931"
			}, {
				"text": "广播电视接收设备制造",
				"value": "3932"
			}, {
				"text": "广播电视专用配件制造",
				"value": "3933"
			}, {
				"text": "专业音响设备制造",
				"value": "3934"
			}],
			"text": "广播电视设备制造",
			"value": "393"
		}, {
			"children": [{
				"text": "电视机制造",
				"value": "3951"
			}, {
				"text": "音响设备制造",
				"value": "3952"
			}, {
				"text": "影视录放设备制造",
				"value": "3953"
			}],
			"text": "非专业视听设备制造",
			"value": "395"
		}, {
			"children": [{
				"text": "雷达及配套设备制造",
				"value": "3940"
			}],
			"text": "雷达及配套设备制造",
			"value": "394"
		}, {
			"children": [{
				"text": "其他智能消费设备制造",
				"value": "3969"
			}, {
				"text": "可穿戴智能设备制造",
				"value": "3961"
			}, {
				"text": "智能车载设备制造",
				"value": "3962"
			}, {
				"text": "智能无人飞行器制造",
				"value": "3963"
			}, {
				"text": "服务消费机器人制造",
				"value": "3964"
			}],
			"text": "智能消费设备制造",
			"value": "396"
		}, {
			"children": [{
				"text": "其他电子器件制造",
				"value": "3979"
			}, {
				"text": "电子真空器件制造",
				"value": "3971"
			}, {
				"text": "半导体分立器件制造",
				"value": "3972"
			}, {
				"text": "集成电路制造",
				"value": "3973"
			}, {
				"text": "显示器件制造",
				"value": "3974"
			}, {
				"text": "半导体照明器件制造",
				"value": "3975"
			}, {
				"text": "光电子器件制造",
				"value": "3976"
			}],
			"text": "电子器件制造",
			"value": "397"
		}, {
			"children": [{
				"text": "通信系统设备制造",
				"value": "3921"
			}, {
				"text": "通信终端设备制造",
				"value": "3922"
			}],
			"text": "通信设备制造",
			"value": "392"
		}, {
			"children": [{
				"text": "其他电子设备制造",
				"value": "3990"
			}],
			"text": "其他电子设备制造",
			"value": "399"
		}],
		"text": "计算机、通信和其他电子设备制造业",
		"value": "39"
	}, {
		"children": [{
			"children": [{
				"text": "非金属废料和碎屑加工处理",
				"value": "4220"
			}],
			"text": "非金属废料和碎屑加工处理",
			"value": "422"
		}, {
			"children": [{
				"text": "金属废料和碎屑加工处理",
				"value": "4210"
			}],
			"text": "金属废料和碎屑加工处理",
			"value": "421"
		}],
		"text": "废弃资源综合利用业 ",
		"value": "42"
	}, {
		"children": [{
			"children": [{
				"text": "海洋工程装备制造",
				"value": "3737"
			}, {
				"text": "航标器材及其他相关装置制造",
				"value": "3739"
			}, {
				"text": "金属船舶制造",
				"value": "3731"
			}, {
				"text": "非金属船舶制造",
				"value": "3732"
			}, {
				"text": "娱乐船和运动船制造",
				"value": "3733"
			}, {
				"text": "船用配套设备制造",
				"value": "3734"
			}, {
				"text": "船舶改装",
				"value": "3735"
			}, {
				"text": "船舶拆除",
				"value": "3736"
			}],
			"text": "船舶及相关装置制造",
			"value": "373"
		}, {
			"children": [{
				"text": "自行车制造",
				"value": "3761"
			}, {
				"text": "残疾人座车制造",
				"value": "3762"
			}],
			"text": "自行车和残疾人座车制造",
			"value": "376"
		}, {
			"children": [{
				"text": "非公路休闲车及零配件制造",
				"value": "3780"
			}],
			"text": "非公路休闲车及零配件制造",
			"value": "378"
		}, {
			"children": [{
				"text": "城市轨道交通设备制造",
				"value": "3720"
			}],
			"text": "城市轨道交通设备制造",
			"value": "372"
		}, {
			"children": [{
				"text": "其他航空航天器制造",
				"value": "3749"
			}, {
				"text": "飞机制造",
				"value": "3741"
			}, {
				"text": "航天器及运载火箭制造",
				"value": "3742"
			}, {
				"text": "航天相关设备制造",
				"value": "3743"
			}, {
				"text": "航空相关设备制造",
				"value": "3744"
			}],
			"text": "航空、航天器及设备制造",
			"value": "374"
		}, {
			"children": [{
				"text": "铁路机车车辆配件制造",
				"value": "3715"
			}, {
				"text": "铁路专用设备及器材、配件制造",
				"value": "3716"
			}, {
				"text": "其他铁路运输设备制造",
				"value": "3719"
			}, {
				"text": "高铁车组制造",
				"value": "3711"
			}, {
				"text": "铁路机车车辆制造",
				"value": "3712"
			}, {
				"text": "窄轨机车车辆制造",
				"value": "3713"
			}, {
				"text": "高铁设备、配件制造",
				"value": "3714"
			}],
			"text": "铁路运输设备制造",
			"value": "371"
		}, {
			"children": [{
				"text": "潜水装备制造",
				"value": "3791"
			}, {
				"text": "水下救捞装备制造",
				"value": "3792"
			}, {
				"text": "其他未列明运输设备制造",
				"value": "3799"
			}],
			"text": "潜水救捞及其他未列明运输设备制造",
			"value": "379"
		}, {
			"children": [{
				"text": "助动车制造",
				"value": "3770"
			}],
			"text": "助动车制造",
			"value": "377"
		}, {
			"children": [{
				"text": "摩托车整车制造",
				"value": "3751"
			}, {
				"text": "摩托车零部件及配件制造",
				"value": "3752"
			}],
			"text": "摩托车制造",
			"value": "375"
		}],
		"text": "铁路、船舶、航空航天和其他运输设备制造业",
		"value": "37"
	}, {
		"children": [{
			"children": [{
				"text": "轮胎制造",
				"value": "2911"
			}, {
				"text": "其他橡胶制品制造",
				"value": "2919"
			}, {
				"text": "运动场地用塑胶制造",
				"value": "2916"
			}, {
				"text": "日用及医用橡胶制品制造",
				"value": "2915"
			}, {
				"text": "再生橡胶制造",
				"value": "2914"
			}, {
				"text": "橡胶零件制造",
				"value": "2913"
			}, {
				"text": "橡胶板、管、带制造",
				"value": "2912"
			}],
			"text": "橡胶制品业",
			"value": "291"
		}, {
			"children": [{
				"text": "塑料板、管、型材制造",
				"value": "2922"
			}, {
				"text": "塑料薄膜制造",
				"value": "2921"
			}, {
				"text": "塑料零件及其他塑料制品制造",
				"value": "2929"
			}, {
				"text": "人造草坪制造",
				"value": "2928"
			}, {
				"text": "日用塑料制品制造",
				"value": "2927"
			}, {
				"text": "塑料包装箱及容器制造",
				"value": "2926"
			}, {
				"text": "塑料人造革、合成革制造",
				"value": "2925"
			}, {
				"text": "泡沫塑料制造",
				"value": "2924"
			}, {
				"text": "塑料丝、绳及编织品制造",
				"value": "2923"
			}],
			"text": "塑料制品业",
			"value": "292"
		}],
		"text": "橡胶和塑料制品业",
		"value": "29"
	}, {
		"children": [{
			"children": [{
				"text": "其他未列明制造业",
				"value": "4190"
			}],
			"text": "其他未列明制造业",
			"value": "419"
		}, {
			"children": [{
				"text": "鬃毛加工、制刷及清扫工具制造",
				"value": "4111"
			}, {
				"text": "其他日用杂品制造",
				"value": "4119"
			}],
			"text": "日用杂品制造",
			"value": "411"
		}, {
			"children": [{
				"text": "核辐射加工",
				"value": "4120"
			}],
			"text": "核辐射加工",
			"value": "412"
		}],
		"text": "其他制造业",
		"value": "41"
	}],
	"text": "制造业",
	"value": "C"
}, {
	"children": [{
		"children": [{
			"children": [{
				"text": "其他未列明卫生服务",
				"value": "8499"
			}, {
				"text": "健康体检服务",
				"value": "8491"
			}, {
				"text": "临床检验服务",
				"value": "8492"
			}],
			"text": "其他卫生活动",
			"value": "849"
		}, {
			"children": [{
				"text": "社区卫生服务中心（站）",
				"value": "8421"
			}, {
				"text": "村卫生室",
				"value": "8424"
			}, {
				"text": "门诊部（所）",
				"value": "8425"
			}, {
				"text": "街道卫生院",
				"value": "8422"
			}, {
				"text": "乡镇卫生院",
				"value": "8423"
			}],
			"text": "基层医疗卫生服务",
			"value": "842"
		}, {
			"children": [{
				"text": "疾病预防控制中心",
				"value": "8431"
			}, {
				"text": "专科疾病防治院（所、站）",
				"value": "8432"
			}, {
				"text": "采供血机构服务",
				"value": "8435"
			}, {
				"text": "计划生育技术服务活动",
				"value": "8436"
			}, {
				"text": "妇幼保健院（所、站）",
				"value": "8433"
			}, {
				"text": "急救中心（站）服务",
				"value": "8434"
			}],
			"text": "专业公共卫生服务",
			"value": "843"
		}, {
			"children": [{
				"text": "中西医结合医院",
				"value": "8413"
			}, {
				"text": "民族医院",
				"value": "8414"
			}, {
				"text": "综合医院",
				"value": "8411"
			}, {
				"text": "中医医院",
				"value": "8412"
			}, {
				"text": "专科医院",
				"value": "8415"
			}, {
				"text": "疗养院",
				"value": "8416"
			}],
			"text": "医院",
			"value": "841"
		}],
		"text": "卫生",
		"value": "84"
	}, {
		"children": [{
			"children": [{
				"text": "护理机构服务",
				"value": "8512"
			}, {
				"text": "精神康复服务",
				"value": "8513"
			}, {
				"text": "干部休养所",
				"value": "8511"
			}, {
				"text": "孤残儿童收养和庇护服务",
				"value": "8516"
			}, {
				"text": "老年人、残疾人养护服务",
				"value": "8514"
			}, {
				"text": "临终关怀服务",
				"value": "8515"
			}, {
				"text": "其他提供住宿社会救助",
				"value": "8519"
			}],
			"text": "提供住宿社会工作",
			"value": "851"
		}, {
			"children": [{
				"text": "社会看护与帮助服务",
				"value": "8521"
			}, {
				"text": "康复辅具适配服务",
				"value": "8522"
			}, {
				"text": "其他不提供住宿社会工作",
				"value": "8529"
			}],
			"text": "不提供住宿社会工作",
			"value": "852"
		}],
		"text": "社会工作",
		"value": "85"
	}],
	"text": "卫生和社会工作",
	"value": "Q"
}, {
	"children": [{
		"children": [{
			"children": [{
				"text": "国际组织",
				"value": "9700"
			}],
			"text": "国际组织",
			"value": "970"
		}],
		"text": "国际组织",
		"value": "97"
	}],
	"text": "国际组织",
	"value": "T"
}, {
	"children": [{
		"children": [{
			"children": [{
				"text": "陆地天然气开采",
				"value": "721"
			}, {
				"text": "海洋天然气及可燃冰开采",
				"value": "722"
			}],
			"text": "天然气开采",
			"value": "72"
		}, {
			"children": [{
				"text": "陆地石油开采",
				"value": "711"
			}, {
				"text": "海洋石油开采",
				"value": "712"
			}],
			"text": "石油开采",
			"value": "71"
		}],
		"text": "石油和天然气开采业",
		"value": "7"
	}, {
		"children": [{
			"children": [{
				"text": "其他黑色金属矿采选",
				"value": "890"
			}],
			"text": "其他黑色金属矿采选",
			"value": "89"
		}, {
			"children": [{
				"text": "铁矿采选",
				"value": "810"
			}],
			"text": "铁矿采选",
			"value": "81"
		}, {
			"children": [{
				"text": "锰矿、铬矿采选",
				"value": "820"
			}],
			"text": "锰矿、铬矿采选",
			"value": "82"
		}],
		"text": "黑色金属矿采选业",
		"value": "8"
	}, {
		"children": [{
			"children": [{
				"text": "石棉、云母矿采选",
				"value": "1091"
			}, {
				"text": "其他未列明非金属矿采选",
				"value": "1099"
			}, {
				"text": "宝石、玉石采选",
				"value": "1093"
			}, {
				"text": "石墨、滑石采选",
				"value": "1092"
			}],
			"text": "石棉及其他非金属矿采选",
			"value": "109"
		}, {
			"children": [{
				"text": "化学矿开采",
				"value": "1020"
			}],
			"text": "化学矿开采",
			"value": "102"
		}, {
			"children": [{
				"text": "粘土及其他土砂石开采",
				"value": "1019"
			}, {
				"text": "耐火土石开采",
				"value": "1013"
			}, {
				"text": "建筑装饰用石开采",
				"value": "1012"
			}, {
				"text": "石灰石、石膏开采",
				"value": "1011"
			}],
			"text": "土砂石开采",
			"value": "101"
		}, {
			"children": [{
				"text": "采盐",
				"value": "1030"
			}],
			"text": "采盐",
			"value": "103"
		}],
		"text": "非金属矿采选业",
		"value": "10"
	}, {
		"children": [{
			"children": [{
				"text": "其他采矿业",
				"value": "1200"
			}],
			"text": "其他采矿业",
			"value": "120"
		}],
		"text": "其他采矿业",
		"value": "12"
	}, {
		"children": [{
			"children": [{
				"text": "石油和天然气开采专业及辅助性活动",
				"value": "1120"
			}],
			"text": "石油和天然气开采专业及辅助性活动",
			"value": "112"
		}, {
			"children": [{
				"text": "煤炭开采和洗选专业及辅助性活动",
				"value": "1110"
			}],
			"text": "煤炭开采和洗选专业及辅助性活动",
			"value": "111"
		}, {
			"children": [{
				"text": "其他开采专业及辅助性活动",
				"value": "1190"
			}],
			"text": "其他开采专业及辅助性活动",
			"value": "119"
		}],
		"text": "开采专业及辅助性活动",
		"value": "11"
	}, {
		"children": [{
			"children": [{
				"text": "其他贵金属矿采选",
				"value": "929"
			}, {
				"text": "金矿采选",
				"value": "921"
			}, {
				"text": "银矿采选",
				"value": "922"
			}],
			"text": "贵金属矿采选",
			"value": "92"
		}, {
			"children": [{
				"text": "钨钼矿采选",
				"value": "931"
			}, {
				"text": "稀土金属矿采选",
				"value": "932"
			}, {
				"text": "放射性金属矿采选",
				"value": "933"
			}, {
				"text": "其他稀有金属矿采选",
				"value": "939"
			}],
			"text": "稀有稀土金属矿采选",
			"value": "93"
		}, {
			"children": [{
				"text": "其他常用有色金属矿采选",
				"value": "919"
			}, {
				"text": "铜矿采选",
				"value": "911"
			}, {
				"text": "铅锌矿采选",
				"value": "912"
			}, {
				"text": "镍钴矿采选",
				"value": "913"
			}, {
				"text": "锡矿采选",
				"value": "914"
			}, {
				"text": "锑矿采选",
				"value": "915"
			}, {
				"text": "铝矿采选",
				"value": "916"
			}, {
				"text": "镁矿采选",
				"value": "917"
			}],
			"text": "常用有色金属矿采选",
			"value": "91"
		}],
		"text": "有色金属矿采选业",
		"value": "9"
	}, {
		"children": [{
			"children": [{
				"text": "烟煤和无烟煤开采洗选",
				"value": "610"
			}],
			"text": "烟煤和无烟煤开采洗选",
			"value": "61"
		}, {
			"children": [{
				"text": "褐煤开采洗选",
				"value": "620"
			}],
			"text": "褐煤开采洗选",
			"value": "62"
		}, {
			"children": [{
				"text": "其他煤炭采选",
				"value": "690"
			}],
			"text": "其他煤炭采选",
			"value": "69"
		}],
		"text": "煤炭开采和洗选业",
		"value": "6"
	}],
	"text": "采矿业",
	"value": "B"
}, {
	"children": [{
		"children": [{
			"children": [{
				"text": "普通高等教育",
				"value": "8341"
			}, {
				"text": "成人高等教育",
				"value": "8342"
			}],
			"text": "高等教育",
			"value": "834"
		}, {
			"children": [{
				"text": "特殊教育",
				"value": "8350"
			}],
			"text": "特殊教育",
			"value": "835"
		}, {
			"children": [{
				"text": "普通小学教育",
				"value": "8321"
			}, {
				"text": "成人小学教育",
				"value": "8322"
			}],
			"text": "初等教育",
			"value": "832"
		}, {
			"children": [{
				"text": "职业初中教育",
				"value": "8332"
			}, {
				"text": "成人初中教育",
				"value": "8333"
			}, {
				"text": "普通初中教育",
				"value": "8331"
			}, {
				"text": "中等职业学校教育",
				"value": "8336"
			}, {
				"text": "普通高中教育",
				"value": "8334"
			}, {
				"text": "成人高中教育",
				"value": "8335"
			}],
			"text": "中等教育",
			"value": "833"
		}, {
			"children": [{
				"text": "其他未列明教育",
				"value": "8399"
			}, {
				"text": "职业技能培训",
				"value": "8391"
			}, {
				"text": "教育辅助服务",
				"value": "8394"
			}, {
				"text": "体校及体育培训",
				"value": "8392"
			}, {
				"text": "文化艺术培训",
				"value": "8393"
			}],
			"text": "技能培训、教育辅助及其他教育",
			"value": "839"
		}, {
			"children": [{
				"text": "学前教育",
				"value": "8310"
			}],
			"text": "学前教育",
			"value": "831"
		}],
		"text": "教育",
		"value": "83"
	}],
	"text": "教育",
	"value": "P"
}, {
	"children": [{
		"children": [{
			"children": [{
				"text": "证券市场管理服务",
				"value": "6711"
			}, {
				"text": "证券经纪交易服务",
				"value": "6712"
			}],
			"text": "证券市场服务",
			"value": "671"
		}, {
			"children": [{
				"text": "公开募集证券投资基金",
				"value": "6720"
			}],
			"text": "公开募集证券投资基金",
			"value": "672"
		}, {
			"children": [{
				"text": "其他资本市场服务",
				"value": "6790"
			}],
			"text": "其他资本市场服务",
			"value": "679"
		}, {
			"children": [{
				"text": "证券期货监管服务",
				"value": "6750"
			}],
			"text": "证券期货监管服务",
			"value": "675"
		}, {
			"children": [{
				"text": "资本投资服务",
				"value": "6760"
			}],
			"text": "资本投资服务",
			"value": "676"
		}, {
			"children": [{
				"text": "创业投资基金",
				"value": "6731"
			}, {
				"text": "天使投资",
				"value": "6732"
			}, {
				"text": "其他非公开募集证券投资基金",
				"value": "6739"
			}],
			"text": "非公开募集证券投资基金",
			"value": "673"
		}, {
			"children": [{
				"text": "期货市场管理服务",
				"value": "6741"
			}, {
				"text": "其他期货市场服务",
				"value": "6749"
			}],
			"text": "期货市场服务",
			"value": "674"
		}],
		"text": "资本市场服务",
		"value": "67"
	}, {
		"children": [{
			"children": [{
				"text": "金融信息服务",
				"value": "6940"
			}],
			"text": "金融信息服务",
			"value": "694"
		}, {
			"children": [{
				"text": "控股公司服务",
				"value": "6920"
			}],
			"text": "控股公司服务",
			"value": "692"
		}, {
			"children": [{
				"text": "货币经纪公司服务",
				"value": "6991"
			}, {
				"text": "其他未包括金融业",
				"value": "6999"
			}],
			"text": "其他未列明金融业",
			"value": "699"
		}, {
			"children": [{
				"text": "金融资产管理公司",
				"value": "6950"
			}],
			"text": "金融资产管理公司",
			"value": "695"
		}, {
			"children": [{
				"text": "其他金融信托与管理服务",
				"value": "6919"
			}, {
				"text": "信托公司",
				"value": "6911"
			}],
			"text": "金融信托与管理服务",
			"value": "691"
		}, {
			"children": [{
				"text": "非金融机构支付服务",
				"value": "6930"
			}],
			"text": "非金融机构支付服务",
			"value": "693"
		}],
		"text": "其他金融业",
		"value": "69"
	}, {
		"children": [{
			"children": [{
				"text": "财务公司服务",
				"value": "6632"
			}, {
				"text": "融资租赁服务",
				"value": "6631"
			}, {
				"text": "汽车金融公司服务",
				"value": "6634"
			}, {
				"text": "典当",
				"value": "6633"
			}, {
				"text": "消费金融公司服务",
				"value": "6636"
			}, {
				"text": "小额贷款公司服务",
				"value": "6635"
			}, {
				"text": "网络借贷服务",
				"value": "6637"
			}, {
				"text": "其他非货币银行服务",
				"value": "6639"
			}],
			"text": "非货币银行服务",
			"value": "663"
		}, {
			"children": [{
				"text": "商业银行服务",
				"value": "6621"
			}, {
				"text": "信用合作社服务",
				"value": "6623"
			}, {
				"text": "政策性银行服务",
				"value": "6622"
			}, {
				"text": "农村资金互助社服务",
				"value": "6624"
			}, {
				"text": "其他货币银行服务",
				"value": "6629"
			}],
			"text": "货币银行服务",
			"value": "662"
		}, {
			"children": [{
				"text": "银行监管服务",
				"value": "6650"
			}],
			"text": "银行监管服务",
			"value": "665"
		}, {
			"children": [{
				"text": "银行理财服务",
				"value": "6640"
			}],
			"text": "银行理财服务",
			"value": "664"
		}, {
			"children": [{
				"text": "中央银行服务",
				"value": "6610"
			}],
			"text": "中央银行服务",
			"value": "661"
		}],
		"text": "货币金融服务",
		"value": "66"
	}, {
		"children": [{
			"children": [{
				"text": "再保险",
				"value": "6830"
			}],
			"text": "再保险",
			"value": "683"
		}, {
			"children": [{
				"text": "财产保险",
				"value": "6820"
			}],
			"text": "财产保险",
			"value": "682"
		}, {
			"children": [{
				"text": "保险代理服务",
				"value": "6852"
			}, {
				"text": "保险经纪服务",
				"value": "6851"
			}, {
				"text": "保险公估服务",
				"value": "6853"
			}],
			"text": "保险中介服务",
			"value": "685"
		}, {
			"children": [{
				"text": "保险监管服务",
				"value": "6870"
			}],
			"text": "保险监管服务",
			"value": "687"
		}, {
			"children": [{
				"text": "其他保险活动",
				"value": "6890"
			}],
			"text": "其他保险活动",
			"value": "689"
		}, {
			"children": [{
				"text": "年金保险",
				"value": "6812"
			}, {
				"text": "人寿保险",
				"value": "6811"
			}, {
				"text": "意外伤害保险",
				"value": "6814"
			}, {
				"text": "健康保险",
				"value": "6813"
			}],
			"text": "人身保险",
			"value": "681"
		}, {
			"children": [{
				"text": "商业养老金",
				"value": "6840"
			}],
			"text": "商业养老金",
			"value": "684"
		}, {
			"children": [{
				"text": "保险资产管理",
				"value": "6860"
			}],
			"text": "保险资产管理",
			"value": "686"
		}],
		"text": "保险业",
		"value": "68"
	}],
	"text": "金融业",
	"value": "J"
}, {
	"children": [{
		"children": [{
			"children": [{
				"text": "咖啡馆服务",
				"value": "6232"
			}, {
				"text": "茶馆服务",
				"value": "6231"
			}, {
				"text": "酒吧服务",
				"value": "6233"
			}, {
				"text": "其他饮料及冷饮服务",
				"value": "6239"
			}],
			"text": "饮料及冷饮服务",
			"value": "623"
		}, {
			"children": [{
				"text": "正餐服务",
				"value": "6210"
			}],
			"text": "正餐服务",
			"value": "621"
		}, {
			"children": [{
				"text": "快餐服务",
				"value": "6220"
			}],
			"text": "快餐服务",
			"value": "622"
		}, {
			"children": [{
				"text": "其他未列明餐饮业",
				"value": "6299"
			}, {
				"text": "小吃服务",
				"value": "6291"
			}],
			"text": "其他餐饮业",
			"value": "629"
		}, {
			"children": [{
				"text": "餐饮配送服务",
				"value": "6241"
			}, {
				"text": "外卖送餐服务",
				"value": "6242"
			}],
			"text": "餐饮配送及外卖送餐服务",
			"value": "624"
		}],
		"text": "餐饮业",
		"value": "62"
	}, {
		"children": [{
			"children": [{
				"text": "民宿服务",
				"value": "6130"
			}],
			"text": "民宿服务",
			"value": "613"
		}, {
			"children": [{
				"text": "其他住宿业",
				"value": "6190"
			}],
			"text": "其他住宿业",
			"value": "619"
		}, {
			"children": [{
				"text": "旅游饭店",
				"value": "6110"
			}],
			"text": "旅游饭店",
			"value": "611"
		}, {
			"children": [{
				"text": "露营地服务",
				"value": "6140"
			}],
			"text": "露营地服务",
			"value": "614"
		}, {
			"children": [{
				"text": "经济型连锁酒店",
				"value": "6121"
			}, {
				"text": "其他一般旅馆",
				"value": "6129"
			}],
			"text": "一般旅馆",
			"value": "612"
		}],
		"text": "住宿业",
		"value": "61"
	}],
	"text": "住宿和餐饮业",
	"value": "H"
}, {
	"children": [{
		"children": [{
			"children": [{
				"text": "文具用品批发",
				"value": "5141"
			}, {
				"text": "体育用品及器材批发",
				"value": "5142"
			}, {
				"text": "图书批发",
				"value": "5143"
			}, {
				"text": "报刊批发",
				"value": "5144"
			}, {
				"text": "音像制品、电子和数字出版物批发",
				"value": "5145"
			}, {
				"text": "首饰、工艺品及收藏品批发",
				"value": "5146"
			}, {
				"text": "乐器批发",
				"value": "5147"
			}, {
				"text": "其他文化用品批发",
				"value": "5149"
			}],
			"text": "文化、体育用品及器材批发",
			"value": "514"
		}, {
			"children": [{
				"text": "摩托车及零配件批发",
				"value": "5173"
			}, {
				"text": "五金产品批发",
				"value": "5174"
			}, {
				"text": "电气设备批发",
				"value": "5175"
			}, {
				"text": "计算机、软件及辅助设备批发",
				"value": "5176"
			}, {
				"text": "通讯设备批发",
				"value": "5177"
			}, {
				"text": "广播影视设备批发",
				"value": "5178"
			}, {
				"text": "其他机械设备及电子产品批发",
				"value": "5179"
			}, {
				"text": "农业机械批发",
				"value": "5171"
			}, {
				"text": "汽车及零配件批发",
				"value": "5172"
			}],
			"text": "机械设备、五金产品及电子产品批发",
			"value": "517"
		}, {
			"children": [{
				"text": "西药批发",
				"value": "5151"
			}, {
				"text": "中药批发",
				"value": "5152"
			}, {
				"text": "动物用药品批发",
				"value": "5153"
			}, {
				"text": "医疗用品及器材批发",
				"value": "5154"
			}],
			"text": "医药及医疗器材批发",
			"value": "515"
		}, {
			"children": [{
				"text": "石油及制品批发",
				"value": "5162"
			}, {
				"text": "非金属矿及制品批发",
				"value": "5163"
			}, {
				"text": "金属及金属矿批发",
				"value": "5164"
			}, {
				"text": "建材批发",
				"value": "5165"
			}, {
				"text": "化肥批发",
				"value": "5166"
			}, {
				"text": "农药批发",
				"value": "5167"
			}, {
				"text": "农用薄膜批发",
				"value": "5168"
			}, {
				"text": "其他化工产品批发",
				"value": "5169"
			}, {
				"text": "煤炭及制品批发",
				"value": "5161"
			}],
			"text": "矿产品、建材及化工产品批发",
			"value": "516"
		}, {
			"children": [{
				"text": "米、面制品及食用油批发",
				"value": "5121"
			}, {
				"text": "糕点、糖果及糖批发",
				"value": "5122"
			}, {
				"text": "果品、蔬菜批发",
				"value": "5123"
			}, {
				"text": "肉、禽、蛋、奶及水产品批发",
				"value": "5124"
			}, {
				"text": "盐及调味品批发",
				"value": "5125"
			}, {
				"text": "营养和保健品批发",
				"value": "5126"
			}, {
				"text": "酒、饮料及茶叶批发",
				"value": "5127"
			}, {
				"text": "烟草制品批发",
				"value": "5128"
			}, {
				"text": "其他食品批发",
				"value": "5129"
			}],
			"text": "食品、饮料及烟草制品批发",
			"value": "512"
		}, {
			"children": [{
				"text": "艺术品代理",
				"value": "5184"
			}, {
				"text": "其他贸易经纪与代理",
				"value": "5189"
			}, {
				"text": "贸易代理",
				"value": "5181"
			}, {
				"text": "一般物品拍卖",
				"value": "5182"
			}, {
				"text": "艺术品、收藏品拍卖",
				"value": "5183"
			}],
			"text": "贸易经纪与代理",
			"value": "518"
		}, {
			"children": [{
				"text": "其他未列明批发业",
				"value": "5199"
			}, {
				"text": "再生物资回收与批发",
				"value": "5191"
			}, {
				"text": "宠物食品用品批发",
				"value": "5192"
			}, {
				"text": "互联网批发",
				"value": "5193"
			}],
			"text": "其他批发业",
			"value": "519"
		}, {
			"children": [{
				"text": "谷物、豆及薯类批发",
				"value": "5111"
			}, {
				"text": "种子批发",
				"value": "5112"
			}, {
				"text": "畜牧渔业饲料批发",
				"value": "5113"
			}, {
				"text": "棉、麻批发",
				"value": "5114"
			}, {
				"text": "林业产品批发",
				"value": "5115"
			}, {
				"text": "牲畜批发",
				"value": "5116"
			}, {
				"text": "渔业产品批发",
				"value": "5117"
			}, {
				"text": "其他农牧产品批发",
				"value": "5119"
			}],
			"text": "农、林、牧、渔产品批发",
			"value": "511"
		}, {
			"children": [{
				"text": "纺织品、针织品及原料批发",
				"value": "5131"
			}, {
				"text": "服装批发",
				"value": "5132"
			}, {
				"text": "鞋帽批发",
				"value": "5133"
			}, {
				"text": "化妆品及卫生用品批发",
				"value": "5134"
			}, {
				"text": "厨具卫具及日用杂品批发",
				"value": "5135"
			}, {
				"text": "灯具、装饰物品批发",
				"value": "5136"
			}, {
				"text": "家用视听设备批发",
				"value": "5137"
			}, {
				"text": "日用家电批发",
				"value": "5138"
			}, {
				"text": "其他家庭用品批发",
				"value": "5139"
			}],
			"text": "纺织、服装及家庭用品批发",
			"value": "513"
		}],
		"text": "批发业",
		"value": "51"
	}, {
		"children": [{
			"children": [{
				"text": "家具零售",
				"value": "5283"
			}, {
				"text": "涂料零售",
				"value": "5284"
			}, {
				"text": "卫生洁具零售",
				"value": "5285"
			}, {
				"text": "木质装饰材料零售",
				"value": "5286"
			}, {
				"text": "陶瓷、石材装饰材料零售",
				"value": "5287"
			}, {
				"text": "其他室内装饰材料零售",
				"value": "5289"
			}, {
				"text": "五金零售",
				"value": "5281"
			}, {
				"text": "灯具零售",
				"value": "5282"
			}],
			"text": "五金、家具及室内装饰材料专门零售",
			"value": "528"
		}, {
			"children": [{
				"text": "文具用品零售",
				"value": "5241"
			}, {
				"text": "体育用品及器材零售",
				"value": "5242"
			}, {
				"text": "图书、报刊零售",
				"value": "5243"
			}, {
				"text": "音像制品、电子和数字出版物零售",
				"value": "5244"
			}, {
				"text": "珠宝首饰零售",
				"value": "5245"
			}, {
				"text": "工艺美术品及收藏品零售",
				"value": "5246"
			}, {
				"text": "乐器零售",
				"value": "5247"
			}, {
				"text": "照相器材零售",
				"value": "5248"
			}, {
				"text": "其他文化用品零售",
				"value": "5249"
			}],
			"text": "文化、体育用品及器材专门零售",
			"value": "524"
		}, {
			"children": [{
				"text": "汽车新车零售",
				"value": "5261"
			}, {
				"text": "汽车旧车零售",
				"value": "5262"
			}, {
				"text": "汽车零配件零售",
				"value": "5263"
			}, {
				"text": "摩托车及零配件零售",
				"value": "5264"
			}, {
				"text": "机动车燃油零售",
				"value": "5265"
			}, {
				"text": "机动车燃气零售",
				"value": "5266"
			}, {
				"text": "机动车充电销售",
				"value": "5267"
			}],
			"text": "汽车、摩托车、零配件和燃料及其他动力销售",
			"value": "526"
		}, {
			"children": [{
				"text": "百货零售",
				"value": "5211"
			}, {
				"text": "超级市场零售",
				"value": "5212"
			}, {
				"text": "便利店零售",
				"value": "5213"
			}, {
				"text": "其他综合零售",
				"value": "5219"
			}],
			"text": "综合零售",
			"value": "521"
		}, {
			"children": [{
				"text": "日用家电零售",
				"value": "5272"
			}, {
				"text": "计算机、软件及辅助设备零售",
				"value": "5273"
			}, {
				"text": "通信设备零售",
				"value": "5274"
			}, {
				"text": "其他电子产品零售",
				"value": "5279"
			}, {
				"text": "家用视听设备零售",
				"value": "5271"
			}],
			"text": "家用电器及电子产品专门零售",
			"value": "527"
		}, {
			"children": [{
				"text": "粮油零售",
				"value": "5221"
			}, {
				"text": "糕点、面包零售",
				"value": "5222"
			}, {
				"text": "果品、蔬菜零售",
				"value": "5223"
			}, {
				"text": "肉、禽、蛋、奶及水产品零售",
				"value": "5224"
			}, {
				"text": "营养和保健品零售",
				"value": "5225"
			}, {
				"text": "酒、饮料及茶叶零售",
				"value": "5226"
			}, {
				"text": "烟草制品零售",
				"value": "5227"
			}, {
				"text": "其他食品零售",
				"value": "5229"
			}],
			"text": "食品、饮料及烟草制品专门零售",
			"value": "522"
		}, {
			"children": [{
				"text": "自动售货机零售",
				"value": "5294"
			}, {
				"text": "旧货零售",
				"value": "5295"
			}, {
				"text": "生活用燃料零售",
				"value": "5296"
			}, {
				"text": "宠物食品用品零售",
				"value": "5297"
			}, {
				"text": "其他未列明零售业",
				"value": "5299"
			}, {
				"text": "流动货摊零售",
				"value": "5291"
			}, {
				"text": "互联网零售",
				"value": "5292"
			}, {
				"text": "邮购及电视、电话零售",
				"value": "5293"
			}],
			"text": "货摊、无店铺及其他零售业",
			"value": "529"
		}, {
			"children": [{
				"text": "西药零售",
				"value": "5251"
			}, {
				"text": "中药零售",
				"value": "5252"
			}, {
				"text": "动物用药品零售",
				"value": "5253"
			}, {
				"text": "医疗用品及器材零售",
				"value": "5254"
			}, {
				"text": "保健辅助治疗器材零售",
				"value": "5255"
			}],
			"text": "医药及医疗器材专门零售",
			"value": "525"
		}, {
			"children": [{
				"text": "纺织品及针织品零售",
				"value": "5231"
			}, {
				"text": "服装零售",
				"value": "5232"
			}, {
				"text": "鞋帽零售",
				"value": "5233"
			}, {
				"text": "化妆品及卫生用品零售",
				"value": "5234"
			}, {
				"text": "厨具卫具及日用杂品零售",
				"value": "5235"
			}, {
				"text": "钟表、眼镜零售",
				"value": "5236"
			}, {
				"text": "箱包零售",
				"value": "5237"
			}, {
				"text": "自行车等代步设备零售",
				"value": "5238"
			}, {
				"text": "其他日用品零售",
				"value": "5239"
			}],
			"text": "纺织、服装及日用品专门零售",
			"value": "523"
		}],
		"text": "零售业",
		"value": "52"
	}],
	"text": "批发和零售业",
	"value": "F"
}, {
	"children": [{
		"children": [{
			"children": [{
				"text": "医学研究和试验发展",
				"value": "7340"
			}],
			"text": "医学研究和试验发展",
			"value": "734"
		}, {
			"children": [{
				"text": "工程和技术研究和试验发展",
				"value": "7320"
			}],
			"text": "工程和技术研究和试验发展",
			"value": "732"
		}, {
			"children": [{
				"text": "社会人文科学研究",
				"value": "7350"
			}],
			"text": "社会人文科学研究",
			"value": "735"
		}, {
			"children": [{
				"text": "自然科学研究和试验发展",
				"value": "7310"
			}],
			"text": "自然科学研究和试验发展",
			"value": "731"
		}, {
			"children": [{
				"text": "农业科学研究和试验发展",
				"value": "7330"
			}],
			"text": "农业科学研究和试验发展",
			"value": "733"
		}],
		"text": "研究和试验发展",
		"value": "73"
	}, {
		"children": [{
			"children": [{
				"text": "创业空间服务",
				"value": "7540"
			}],
			"text": "创业空间服务",
			"value": "754"
		}, {
			"children": [{
				"text": "其他科技推广服务业",
				"value": "7590"
			}],
			"text": "其他科技推广服务业",
			"value": "759"
		}, {
			"children": [{
				"text": "生物技术推广服务",
				"value": "7512"
			}, {
				"text": "农林牧渔技术推广服务",
				"value": "7511"
			}, {
				"text": "节能技术推广服务",
				"value": "7514"
			}, {
				"text": "新材料技术推广服务",
				"value": "7513"
			}, {
				"text": "环保技术推广服务",
				"value": "7516"
			}, {
				"text": "新能源技术推广服务",
				"value": "7515"
			}, {
				"text": "三维（3D）打印技术推广服务",
				"value": "7517"
			}, {
				"text": "其他技术推广服务",
				"value": "7519"
			}],
			"text": "技术推广服务",
			"value": "751"
		}, {
			"children": [{
				"text": "知识产权服务",
				"value": "7520"
			}],
			"text": "知识产权服务",
			"value": "752"
		}, {
			"children": [{
				"text": "科技中介服务",
				"value": "7530"
			}],
			"text": "科技中介服务",
			"value": "753"
		}],
		"text": "科技推广和应用服务业",
		"value": "75"
	}, {
		"children": [{
			"children": [{
				"text": "气象服务",
				"value": "7410"
			}],
			"text": "气象服务",
			"value": "741"
		}, {
			"children": [{
				"text": "水、二氧化碳等矿产地质勘查",
				"value": "7473"
			}, {
				"text": "固体矿产地质勘查",
				"value": "7472"
			}, {
				"text": "地质勘查技术服务",
				"value": "7475"
			}, {
				"text": "基础地质勘查",
				"value": "7474"
			}, {
				"text": "能源矿产地质勘查",
				"value": "7471"
			}],
			"text": "地质勘查",
			"value": "747"
		}, {
			"children": [{
				"text": "生态资源监测",
				"value": "7462"
			}, {
				"text": "环境保护监测",
				"value": "7461"
			}, {
				"text": "野生动物疫源疫病防控监测",
				"value": "7463"
			}],
			"text": "环境与生态监测检测服务",
			"value": "746"
		}, {
			"children": [{
				"text": "检验检疫服务",
				"value": "7451"
			}, {
				"text": "计量服务",
				"value": "7453"
			}, {
				"text": "检测服务",
				"value": "7452"
			}, {
				"text": "认证认可服务",
				"value": "7455"
			}, {
				"text": "标准化服务",
				"value": "7454"
			}, {
				"text": "其他质检技术服务",
				"value": "7459"
			}],
			"text": "质检技术服务",
			"value": "745"
		}, {
			"children": [{
				"text": "工程设计活动",
				"value": "7484"
			}, {
				"text": "工程勘察活动",
				"value": "7483"
			}, {
				"text": "土地规划服务",
				"value": "7486"
			}, {
				"text": "规划设计管理",
				"value": "7485"
			}, {
				"text": "工程监理服务",
				"value": "7482"
			}, {
				"text": "工程管理服务",
				"value": "7481"
			}],
			"text": "工程技术与设计服务",
			"value": "748"
		}, {
			"children": [{
				"text": "遥感测绘服务",
				"value": "7441"
			}, {
				"text": "其他测绘地理信息服务",
				"value": "7449"
			}],
			"text": "测绘地理信息服务",
			"value": "744"
		}, {
			"children": [{
				"text": "地震服务",
				"value": "7420"
			}],
			"text": "地震服务",
			"value": "742"
		}, {
			"children": [{
				"text": "其他未列明专业技术服务业",
				"value": "7499"
			}, {
				"text": "工业设计服务",
				"value": "7491"
			}, {
				"text": "兽医服务",
				"value": "7493"
			}, {
				"text": "专业设计服务",
				"value": "7492"
			}],
			"text": "工业与专业设计及其他专业技术服务",
			"value": "749"
		}, {
			"children": [{
				"text": "海洋气象服务",
				"value": "7431"
			}, {
				"text": "海洋环境服务",
				"value": "7432"
			}, {
				"text": "其他海洋服务",
				"value": "7439"
			}],
			"text": "海洋服务",
			"value": "743"
		}],
		"text": "专业技术服务业",
		"value": "74"
	}],
	"text": "科学研究和技术服务业",
	"value": "M"
}]